/**
 * Copyright IBM Corp. 2016, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * Code generated by @carbon/icon-build-helpers. DO NOT EDIT.
 */
import React from 'react';
import Icon from '../Icon.js';
import { i as iconPropTypes } from '../iconPropTypes-4cbeb95d.js';
import '@core/icon-helpers';
import 'prop-types';

var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _circle, _path10, _path11, _path12, _path13, _path14, _circle2, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _rect, _path49, _path50, _path51, _path52, _circle3, _circle4, _circle5, _path53, _path54, _path55, _circle6, _circle7, _circle8, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _circle9, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _circle0, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404;
const TcpIpService = /*#__PURE__*/React.forwardRef(function TcpIpService({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 28H30V30H16z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27,26h-8c-1.1028,0-2-.8972-2-2v-5c0-1.1028,.8972-2,2-2h8c1.1028,0,2,.8972,2,2v5c0,1.1028-.8972,2-2,2Zm-8-7v5h8v-5h-8Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15,23h-5c-1.1028,0-2-.8972-2-2v-4h2v4h5v2Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2 13H16V15H2z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13,11H5c-1.1028,0-2-.8972-2-2V4c0-1.1028,.8972-2,2-2H13c1.1028,0,2,.8972,2,2v5c0,1.1028-.8972,2-2,2ZM5,4v5H13V4H5Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  TcpIpService.propTypes = iconPropTypes;
}
const Temperature = /*#__PURE__*/React.forwardRef(function Temperature({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13,17.26V6A4,4,0,0,0,5,6V17.26a7,7,0,1,0,8,0ZM9,4a2,2,0,0,1,2,2v7H7V6A2,2,0,0,1,9,4ZM9,28a5,5,0,0,1-2.5-9.33l.5-.28V15h4v3.39l.5.28A5,5,0,0,1,9,28Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20 4H30V6H20z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M20 10H27V12H20z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M20 16H30V18H20z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M20 22H27V24H20z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Temperature.propTypes = iconPropTypes;
}
const TemperatureCelsius = /*#__PURE__*/React.forwardRef(function TemperatureCelsius({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M30,18H24a2.0023,2.0023,0,0,1-2-2V6a2.002,2.002,0,0,1,2-2h6V6H24V16h6Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: "18",
    cy: "4",
    r: "2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M10,20.1841V12H8v8.1841a3,3,0,1,0,2,0Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M9,30A6.9931,6.9931,0,0,1,4,18.1108V7A5,5,0,0,1,14,7V18.1108A6.9931,6.9931,0,0,1,9,30ZM9,4A3.0033,3.0033,0,0,0,6,7V18.9834l-.332.2983a5,5,0,1,0,6.664,0L12,18.9834V7A3.0033,3.0033,0,0,0,9,4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  TemperatureCelsius.propTypes = iconPropTypes;
}
const TemperatureCelsiusAlt = /*#__PURE__*/React.forwardRef(function TemperatureCelsiusAlt({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M26,27H17a2.0023,2.0023,0,0,1-2-2V11a2.002,2.002,0,0,1,2-2h9v2H17V25h9Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M8,13a4,4,0,1,1,4-4h0A4.0118,4.0118,0,0,1,8,13ZM8,7a2,2,0,1,0,2,2h0A2.0059,2.0059,0,0,0,8,7Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  TemperatureCelsiusAlt.propTypes = iconPropTypes;
}
const TemperatureFahrenheit = /*#__PURE__*/React.forwardRef(function TemperatureFahrenheit({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M30 6L30 4 22 4 22 18 24 18 24 12 29 12 29 10 24 10 24 6 30 6z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: "18",
    cy: "4",
    r: "2"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M10,20.1841V12H8v8.1841a3,3,0,1,0,2,0Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M9,30A6.9931,6.9931,0,0,1,4,18.1108V7A5,5,0,0,1,14,7V18.1108A6.9931,6.9931,0,0,1,9,30ZM9,4A3.0033,3.0033,0,0,0,6,7V18.9834l-.332.2983a5,5,0,1,0,6.664,0L12,18.9834V7A3.0033,3.0033,0,0,0,9,4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  TemperatureFahrenheit.propTypes = iconPropTypes;
}
const TemperatureFahrenheitAlt = /*#__PURE__*/React.forwardRef(function TemperatureFahrenheitAlt({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M26 11L26 9 15 9 15 27 17 27 17 19 25 19 25 17 17 17 17 11 26 11z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M8,13a4,4,0,1,1,4-4h0A4.0118,4.0118,0,0,1,8,13ZM8,7a2,2,0,1,0,2,2h0A2.0059,2.0059,0,0,0,8,7Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  TemperatureFahrenheitAlt.propTypes = iconPropTypes;
}
const TemperatureFeelsLike = /*#__PURE__*/React.forwardRef(function TemperatureFeelsLike({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M26,30H22a2.0059,2.0059,0,0,1-2-2V21a2.0059,2.0059,0,0,1-2-2V13a2.9465,2.9465,0,0,1,3-3h6a2.9465,2.9465,0,0,1,3,3v6a2.0059,2.0059,0,0,1-2,2v7A2.0059,2.0059,0,0,1,26,30ZM21,12a.9448.9448,0,0,0-1,1v6h2v9h4V19h2V13a.9448.9448,0,0,0-1-1Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M24,9a4,4,0,1,1,4-4h0A4.0118,4.0118,0,0,1,24,9Zm0-6a2,2,0,1,0,2,2h0a2.0059,2.0059,0,0,0-2-2Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M10,20.1839V12H8v8.1839a3,3,0,1,0,2,0Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M9,30A6.9931,6.9931,0,0,1,4,18.1108V7A5,5,0,0,1,14,7V18.1108A6.9931,6.9931,0,0,1,9,30ZM9,4A3.0033,3.0033,0,0,0,6,7V18.9834l-.332.2983a5,5,0,1,0,6.664,0L12,18.9834V7A3.0033,3.0033,0,0,0,9,4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  TemperatureFeelsLike.propTypes = iconPropTypes;
}
const TemperatureFrigid = /*#__PURE__*/React.forwardRef(function TemperatureFrigid({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M27.167 16.89L21.72 13 27.167 9.109 29.684 9.948 30.316 8.051 28 7.279 28 5 26 5 26 7.485 21 11.057 21 5.367 23.555 3.664 22.445 2 20 3.63 17.555 2 16.445 3.664 19 5.367 19 11.057 16 8.914 16 11.372 18.28 13 16 14.628 16 17.086 19 14.943 19 21.703 22.445 24 23.555 22.336 21 20.633 21 14.943 26 18.515 26 21 28 21 28 18.721 30.316 17.948 29.684 16.051 27.167 16.89z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M12,23a3,3,0,0,1-6,0Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M9,30A6.9931,6.9931,0,0,1,4,18.1108V7A5,5,0,0,1,14,7V18.1108A6.9931,6.9931,0,0,1,9,30ZM9,4A3.0033,3.0033,0,0,0,6,7V18.9834l-.332.2983a5,5,0,1,0,6.664,0L12,18.9834V7A3.0033,3.0033,0,0,0,9,4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  TemperatureFrigid.propTypes = iconPropTypes;
}
const TemperatureHot = /*#__PURE__*/React.forwardRef(function TemperatureHot({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M26 13H30V15H26z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M23.121 5.879H27.121V7.879H23.121z",
    transform: "rotate(-45 25.121 6.879)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M24.121 19.121H26.121V23.121H24.121z",
    transform: "rotate(-45 25.121 21.121)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M17 2H19V6H17z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M18,8a6.0365,6.0365,0,0,0-1,.09v2.0518A3.9567,3.9567,0,0,1,18,10a4,4,0,0,1,0,8v2A6,6,0,0,0,18,8Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M10,20.1839V7H8V20.1839a3,3,0,1,0,2,0Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M9,30A6.9931,6.9931,0,0,1,4,18.1108V7A5,5,0,0,1,14,7V18.1108A6.9931,6.9931,0,0,1,9,30ZM9,4A3.0033,3.0033,0,0,0,6,7V18.9834l-.332.2983a5,5,0,1,0,6.664,0L12,18.9834V7A3.0033,3.0033,0,0,0,9,4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  TemperatureHot.propTypes = iconPropTypes;
}
const TemperatureInversion = /*#__PURE__*/React.forwardRef(function TemperatureInversion({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M30,8H24v6h2V11.541A5.939,5.939,0,0,1,28,16a6.0039,6.0039,0,0,1-5.0945,5.9243A7.0273,7.0273,0,0,0,20,17.2617V6a4,4,0,0,0-8,0V17.2617a6.996,6.996,0,1,0,10.9292,6.68A7.9794,7.9794,0,0,0,27.2651,10H30ZM14,6a2,2,0,0,1,4,0v7H14Zm2,22a4.9965,4.9965,0,0,1-2.499-9.3252L14,18.3857V15h4v3.3857l.499.2891A4.9965,4.9965,0,0,1,16,28Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M2,10a8.04,8.04,0,0,0,2.7349,6H2v2H8V12H6v2.4592A5.94,5.94,0,0,1,4,10a6.0066,6.0066,0,0,1,6-6V2A8.0092,8.0092,0,0,0,2,10Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  TemperatureInversion.propTypes = iconPropTypes;
}
const TemperatureMax = /*#__PURE__*/React.forwardRef(function TemperatureMax({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M20 10H27V12H20z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M20 16H30V18H20z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M20 22H27V24H20z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M10,20.1839V7H8V20.1839a3,3,0,1,0,2,0Z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M30,4H12.9744A4.9829,4.9829,0,0,0,4,7V18.1108a7,7,0,1,0,10,0V7a5.0019,5.0019,0,0,0-.1011-1H30ZM9,28a4.9933,4.9933,0,0,1-3.332-8.7183L6,18.9834V7a3,3,0,0,1,6,0V18.9834l.332.2983A4.9933,4.9933,0,0,1,9,28Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  TemperatureMax.propTypes = iconPropTypes;
}
const TemperatureMin = /*#__PURE__*/React.forwardRef(function TemperatureMin({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M20 4H27V6H20z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M20 10H30V12H20z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M20 16H27V18H20z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M12,23a3,3,0,0,1-6,0Z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M30,22H15.9192A7.0107,7.0107,0,0,0,14,18.1108V7A5,5,0,0,0,4,7V18.1108A6.9946,6.9946,0,1,0,15.92,24H30ZM9,28a4.9933,4.9933,0,0,1-3.332-8.7183L6,18.9834V7a3,3,0,0,1,6,0V18.9834l.332.2983A4.9933,4.9933,0,0,1,9,28Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  TemperatureMin.propTypes = iconPropTypes;
}
const TemperatureWater = /*#__PURE__*/React.forwardRef(function TemperatureWater({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M14,9a4.9316,4.9316,0,0,0,4-1.9873,5.0192,5.0192,0,0,0,8,0A4.9316,4.9316,0,0,0,30,9V7a3.4376,3.4376,0,0,1-3.0513-2.3164A1.007,1.007,0,0,0,26,4a.9894.9894,0,0,0-.9468.6787A3.44,3.44,0,0,1,22,7a3.4376,3.4376,0,0,1-3.0513-2.3164A1.007,1.007,0,0,0,18,4a.971.971,0,0,0-.9468.6787A3.44,3.44,0,0,1,14,7H13V6A4,4,0,0,0,5,6V17.2617A7.0126,7.0126,0,1,0,13.8735,18H14a4.9316,4.9316,0,0,0,4-1.9873,5.0192,5.0192,0,0,0,8,0A4.9316,4.9316,0,0,0,30,18V16a3.4376,3.4376,0,0,1-3.0513-2.3164A1.007,1.007,0,0,0,26,13a.9894.9894,0,0,0-.9468.6787A3.44,3.44,0,0,1,22,16a3.4376,3.4376,0,0,1-3.0513-2.3164A1.007,1.007,0,0,0,18,13a.971.971,0,0,0-.9468.6787A3.44,3.44,0,0,1,14,16H13V9ZM7,6a2,2,0,0,1,4,0v6H7ZM9,28a4.9965,4.9965,0,0,1-2.499-9.3252L7,18.3857V14h4v4.3857l.499.2891A4.9965,4.9965,0,0,1,9,28Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  TemperatureWater.propTypes = iconPropTypes;
}
const Template = /*#__PURE__*/React.forwardRef(function Template({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M26,6v4H6V6H26m0-2H6A2,2,0,0,0,4,6v4a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6a2,2,0,0,0-2-2Z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M10,16V26H6V16h4m0-2H6a2,2,0,0,0-2,2V26a2,2,0,0,0,2,2h4a2,2,0,0,0,2-2V16a2,2,0,0,0-2-2Z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M26,16V26H16V16H26m0-2H16a2,2,0,0,0-2,2V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V16a2,2,0,0,0-2-2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Template.propTypes = iconPropTypes;
}
const Tennis = /*#__PURE__*/React.forwardRef(function Tennis({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: "4",
    height: "4",
    x: "20",
    y: "2",
    rx: "2"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M11,16a1,1,0,0,1-.707-1.707l7-7a1,1,0,1,1,1.414,1.414l-7,7A.9962.9962,0,0,1,11,16Z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M23.707,24.293a8.3948,8.3948,0,0,0-4.72-2.209c.1992-.1641.3931-.3364.5777-.521a9.2447,9.2447,0,0,0,1.7334-9.9141l-1.8768.6973c1.11,2.9805.6346,5.8975-1.2722,7.8022a6.6964,6.6964,0,0,1-5.561,1.8047,9.7746,9.7746,0,0,1-5.771-2.7856c-2.9727-2.97-4.0759-8.2276-.9805-11.32,1.9068-1.9053,4.8267-2.38,7.8094-1.271l.6987-1.875C10.6616,3.333,6.8591,3.9961,4.4207,6.4331c-3.9427,3.9385-2.6761,10.4956.98,14.1489a11.8136,11.8136,0,0,0,6.9766,3.36c.21.022.4153.0234.6223.0332V24h4.9968a6.8463,6.8463,0,0,1,4.2962,1.707L26.5859,30,28,28.5859Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Tennis.propTypes = iconPropTypes;
}
const TennisBall = /*#__PURE__*/React.forwardRef(function TennisBall({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M19,4a8.9812,8.9812,0,0,0-8.1687,12.7549L2,25.5859,3.4141,27l8.4873-8.4873a9.0408,9.0408,0,0,0,1.5859,1.5859L10,23.5859,11.4141,25l3.8313-3.8311A8.9959,8.9959,0,1,0,19,4Zm6.9058,7.9058a7.005,7.005,0,0,1-5.8116-5.8116A7.005,7.005,0,0,1,25.9058,11.9058ZM12.0942,14.0942a7.005,7.005,0,0,1,5.8116,5.8116A7.005,7.005,0,0,1,12.0942,14.0942ZM19.93,19.9307a9.01,9.01,0,0,0-7.8611-7.8614,7.004,7.004,0,0,1,6-6,9.01,9.01,0,0,0,7.8611,7.8614A7.004,7.004,0,0,1,19.93,19.9307Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  TennisBall.propTypes = iconPropTypes;
}
const Term = /*#__PURE__*/React.forwardRef(function Term({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M28,26H25V24h3V8H25V6h3a2.0023,2.0023,0,0,1,2,2V24A2.0027,2.0027,0,0,1,28,26Z"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: "23",
    cy: "16",
    r: "2"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "16",
    r: "2"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "16",
    r: "2"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M7,26H4a2.0023,2.0023,0,0,1-2-2V8A2.002,2.002,0,0,1,4,6H7V8H4V24H7Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Term.propTypes = iconPropTypes;
}
const TermReference = /*#__PURE__*/React.forwardRef(function TermReference({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m28,25h-3v-2h3V7h-3v-2h3c1.1025,0,2,.897,2,2v16c0,1.1025-.8975,2-2,2Z"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: "23",
    cy: "15",
    r: "2",
    strokeWidth: "0"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "15",
    r: "2",
    strokeWidth: "0"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "15",
    r: "2",
    strokeWidth: "0"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m4,17V7h3v-2h-3c-1.103,0-2,.897-2,2v10h2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  TermReference.propTypes = iconPropTypes;
}
const Terminal = /*#__PURE__*/React.forwardRef(function Terminal({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4Zm0,2v4H6V6ZM6,26V12H26V26Z",
    transform: "translate(0 .01)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M10.76 16.18L13.58 19.01 10.76 21.84 12.17 23.25 16.41 19.01 12.17 14.77 10.76 16.18z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Terminal.propTypes = iconPropTypes;
}
const Terminal_3270 = /*#__PURE__*/React.forwardRef(function Terminal_3270({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M10 21H16V23H10z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4Zm0,2v4H6V6ZM6,26V12H26V26Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Terminal_3270.propTypes = iconPropTypes;
}
const TestTool = /*#__PURE__*/React.forwardRef(function TestTool({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M23 9.2L20.4 6.6 19 8 23 12 30 5 28.6 3.6z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M12 5.4L10.6 4 8 6.6 5.4 4 4 5.4 6.6 8 4 10.6 5.4 12 8 9.4 10.6 12 12 10.6 9.4 8z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M12 21.4L10.6 20 8 22.6 5.4 20 4 21.4 6.6 24 4 26.6 5.4 28 8 25.4 10.6 28 12 26.6 9.4 24z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M17 15L17 2 15 2 15 15 2 15 2 17 15 17 15 30 17 30 17 17 30 17 30 15z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  TestTool.propTypes = iconPropTypes;
}
const TextAlignCenter = /*#__PURE__*/React.forwardRef(function TextAlignCenter({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M6 6H26V8H6z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M10 12H22V14H10z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M6 18H26V20H6z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M10 24H22V26H10z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  TextAlignCenter.propTypes = iconPropTypes;
}
const TextAlignJustify = /*#__PURE__*/React.forwardRef(function TextAlignJustify({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M6 6H26V8H6z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M6 12H26V14H6z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M6 18H26V20H6z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M6 24H26V26H6z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  TextAlignJustify.propTypes = iconPropTypes;
}
const TextAlignLeft = /*#__PURE__*/React.forwardRef(function TextAlignLeft({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M12 6H26V8H12z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M12 12H22V14H12z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M12 18H26V20H12z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M12 24H22V26H12z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M6 4H8V28H6z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  TextAlignLeft.propTypes = iconPropTypes;
}
const TextAlignMixed = /*#__PURE__*/React.forwardRef(function TextAlignMixed({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M14,4H9V6h5V8H10a2,2,0,0,0-2,2v2a2,2,0,0,0,2,2h6V6A2.0023,2.0023,0,0,0,14,4Zm0,8H10V10h4Z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M22 26L22 18 20 18 20 19 18 19 18 21 20 21 20 26 18 26 18 28 24 28 24 26 22 26z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M2 2H4V16H2z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M28 16H30V30H28z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  TextAlignMixed.propTypes = iconPropTypes;
}
const TextAlignRight = /*#__PURE__*/React.forwardRef(function TextAlignRight({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M6 6H20V8H6z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M10 12H20V14H10z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M6 18H20V20H6z"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M10 24H20V26H10z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M24 4H26V28H24z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  TextAlignRight.propTypes = iconPropTypes;
}
const TextAllCaps = /*#__PURE__*/React.forwardRef(function TextAllCaps({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M1 8L1 10 7 10 7 24 9 24 9 10 15 10 15 8 1 8z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M17 8L17 10 23 10 23 24 25 24 25 10 31 10 31 8 17 8z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  TextAllCaps.propTypes = iconPropTypes;
}
const TextBold = /*#__PURE__*/React.forwardRef(function TextBold({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M18.25,25H9V7h8.5a5.25,5.25,0,0,1,4,8.65A5.25,5.25,0,0,1,18.25,25ZM12,22h6.23a2.25,2.25,0,1,0,0-4.5H12Zm0-7.5h5.5a2.25,2.25,0,1,0,0-4.5H12Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  TextBold.propTypes = iconPropTypes;
}
const TextClearFormat = /*#__PURE__*/React.forwardRef(function TextClearFormat({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4384,16.5715l-7.985-7.9856a2.0014,2.0014,0,0,0-2.8291,0l-5.3584,5.3584L9,2H7L2,16H4l.999-3h6l.8035,2.4077L4.5858,22.6244a2,2,0,0,0,0,2.8282L9.1316,30h9.5908l10.716-10.717A1.9173,1.9173,0,0,0,29.4384,16.5715ZM5.6653,11l2.331-7,2.3355,7Zm12.229,17H9.96L6,24.0381l6.3123-6.3115L20.24,25.6538Zm3.76-3.76-7.9275-7.9272L20.0393,10l7.9268,7.9272Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  TextClearFormat.propTypes = iconPropTypes;
}
const TextColor = /*#__PURE__*/React.forwardRef(function TextColor({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M22,21h2L17,4H15L8,21h2l1.61-4h8.74Zm-9.57-6,3.44-8.37h.26L19.54,15Z"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M6 24H26V28H6z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  TextColor.propTypes = iconPropTypes;
}
const TextCreation = /*#__PURE__*/React.forwardRef(function TextCreation({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M27,22.14V9.86A4,4,0,1,0,22.14,5H9.86A4,4,0,1,0,5,9.86V22.14A4,4,0,1,0,9.86,27H22.14A4,4,0,1,0,27,22.14ZM26,4a2,2,0,1,1-2,2A2,2,0,0,1,26,4ZM4,6A2,2,0,1,1,6,8,2,2,0,0,1,4,6ZM6,28a2,2,0,1,1,2-2A2,2,0,0,1,6,28Zm16.14-3H9.86A4,4,0,0,0,7,22.14V9.86A4,4,0,0,0,9.86,7H22.14A4,4,0,0,0,25,9.86V22.14A4,4,0,0,0,22.14,25ZM26,28a2,2,0,1,1,2-2A2,2,0,0,1,26,28Z"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M21 11L11 11 11 13 15 13 15 22 17 22 17 13 21 13 21 11z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  TextCreation.propTypes = iconPropTypes;
}
const TextFill = /*#__PURE__*/React.forwardRef(function TextFill({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M4 26H28V30H4z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M26,14.54a1,1,0,0,0-.25-.69L17.17,4.33A1.09,1.09,0,0,0,17,4.2V2H15V5L4.32,14.74a1,1,0,0,0-.06,1.41l8.57,9.52a1,1,0,0,0,.69.33h.05a1,1,0,0,0,.68-.26L24,16.8V21a1,1,0,0,0,2,0V14.57S26,14.55,26,14.54Zm-12.35,9-7.23-8L15,7.67V12h2V7.13l6.59,7.33Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  TextFill.propTypes = iconPropTypes;
}
const TextFont = /*#__PURE__*/React.forwardRef(function TextFont({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M25,12H20v2h5a1.0008,1.0008,0,0,1,1,1v2H22a3.0033,3.0033,0,0,0-3,3v1a3.0033,3.0033,0,0,0,3,3h6V15A3.0033,3.0033,0,0,0,25,12ZM22,22a1.0008,1.0008,0,0,1-1-1V20a1.0008,1.0008,0,0,1,1-1h4v3Z"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M16,24h2L12,7H10L4,24H6l1.6936-5h6.6135ZM8.3711,17l2.4966-7.3711.2668.0005L13.63,17Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  TextFont.propTypes = iconPropTypes;
}
const TextFootnote = /*#__PURE__*/React.forwardRef(function TextFootnote({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M2 7L2 9 9 9 9 25 11 25 11 9 18 9 18 7 2 7z"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M30 11.076L29.256 9.219 26 10.522 26 7 24 7 24 10.523 20.744 9.22 20 11.077 23.417 12.444 20.9 15.8 22.5 17 25 13.667 27.5 17 29.1 15.8 26.583 12.443 30 11.076z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  TextFootnote.propTypes = iconPropTypes;
}
const TextHighlight = /*#__PURE__*/React.forwardRef(function TextHighlight({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M12,15H5a3,3,0,0,1-3-3V10A3,3,0,0,1,5,7h5V5A1,1,0,0,0,9,4H3V2H9a3,3,0,0,1,3,3ZM5,9a1,1,0,0,0-1,1v2a1,1,0,0,0,1,1h5V9Z"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M20,23v2a1,1,0,0,0,1,1h5V22H21A1,1,0,0,0,20,23Z"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M2,30H30V2Zm26-2H21a3,3,0,0,1-3-3V23a3,3,0,0,1,3-3h5V18a1,1,0,0,0-1-1H19V15h6a3,3,0,0,1,3,3Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  TextHighlight.propTypes = iconPropTypes;
}
const TextIndent = /*#__PURE__*/React.forwardRef(function TextIndent({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M14 6H28V8H14z"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M14 12H28V14H14z"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M7 18H28V20H7z"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M7 24H28V26H7z"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M4 13.59L7.29 10 4 6.41 5.42 5 10.04 10 5.42 15 4 13.59z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  TextIndent.propTypes = iconPropTypes;
}
const TextIndentLess = /*#__PURE__*/React.forwardRef(function TextIndentLess({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M2 6H12V8H2z"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M5 12H12V14H5z"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M2 18H12V20H2z"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M5 24H12V26H5z"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M16 4H18V28H16z"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M28.15 23.5L29.56 22.12 23.27 16 29.56 9.88 28.15 8.5 20.44 16 28.15 23.5z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  TextIndentLess.propTypes = iconPropTypes;
}
const TextIndentMore = /*#__PURE__*/React.forwardRef(function TextIndentMore({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M20 6H30V8H20z"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M20 12H27V14H20z"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M20 18H30V20H20z"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M20 24H27V26H20z"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M14 4H16V28H14z"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M3.85 22.5L2.44 21.12 8.73 15 2.44 8.88 3.85 7.5 11.56 15 3.85 22.5z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  TextIndentMore.propTypes = iconPropTypes;
}
const TextItalic = /*#__PURE__*/React.forwardRef(function TextItalic({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M25 9L25 7 12 7 12 9 17.14 9 12.77 23 7 23 7 25 20 25 20 23 14.86 23 19.23 9 25 9z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  TextItalic.propTypes = iconPropTypes;
}
const TextKerning = /*#__PURE__*/React.forwardRef(function TextKerning({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M30 24L18.83 24 21.12 21.71 19.71 20.29 15 25 19.71 29.71 21.12 28.29 18.83 26 30 26 30 24z"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M14 21L20 4 18 4 12 21 14 21z"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M13 4L9 16 5 4 3 4 8 18 10 18 15 4 13 4z"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M28,18h2L25,4H23L18,18h2l1-3h6Zm-6.33-5L24,6l2.33,7Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  TextKerning.propTypes = iconPropTypes;
}
const TextLeading = /*#__PURE__*/React.forwardRef(function TextLeading({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M14 13H30V15H14z"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M15 28H30V30H15z"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M25.85,27H28L23.64,17H21.36L17,27h2.15l.8-2h5.1Zm-5.1-4,1.75-4.37L24.25,23Z"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M25.85,12H28L23.64,2H21.36L17,12h2.15l.8-2h5.1Zm-5.1-4L22.5,3.63,24.25,8Z"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M6 15.83L8.58 18.41 10 17 6 13 2 17 3.41 18.42 6 15.83z"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M6 27.17L3.42 24.59 2 26 6 30 10 26 8.59 24.58 6 27.17z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  TextLeading.propTypes = iconPropTypes;
}
const TextLineSpacing = /*#__PURE__*/React.forwardRef(function TextLineSpacing({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M17 6H30V8H17z"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M17 12H27V14H17z"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M17 18H30V20H17z"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M17 24H27V26H17z"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M11.59 13.41L8 9.83 8 9.83 4.41 13.42 3 12 8 7 13 12 11.59 13.41z"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M11.59 18.59L8 22.17 8 22.17 4.41 18.58 3 20 8 25 13 20 11.59 18.59z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  TextLineSpacing.propTypes = iconPropTypes;
}
const TextLongParagraph = /*#__PURE__*/React.forwardRef(function TextLongParagraph({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M6 24H20V26H6z"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M6 18H26V20H6z"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M6 12H26V14H6z"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M6 6H26V8H6z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  TextLongParagraph.propTypes = iconPropTypes;
}
const TextNewLine = /*#__PURE__*/React.forwardRef(function TextNewLine({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5859,14.4141,24.1719,18H6V8H4V18a2.0024,2.0024,0,0,0,2,2H24.1719L20.586,23.5859,22,25l6-6-6-6Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  TextNewLine.propTypes = iconPropTypes;
}
const TextScale = /*#__PURE__*/React.forwardRef(function TextScale({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M30 5L30 8 22 8 22 26 19 26 19 8 11 8 11 5 30 5z"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M7 26L7 14 2 14 2 12 14 12 14 14 9 14 9 26 7 26z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  TextScale.propTypes = iconPropTypes;
}
const TextSelection = /*#__PURE__*/React.forwardRef(function TextSelection({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M28,27H21a3,3,0,0,1-3-3V22a3,3,0,0,1,3-3h5V17a1,1,0,0,0-1-1H19V14h6a3,3,0,0,1,3,3Zm-7-6a1,1,0,0,0-1,1v2a1,1,0,0,0,1,1h5V21Z"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M13,7h3V5H13a4,4,0,0,0-3,1.38A4,4,0,0,0,7,5H4V7H7A2,2,0,0,1,9,9v5H5v2H9v7a2,2,0,0,1-2,2H4v2H7a4,4,0,0,0,3-1.38A4,4,0,0,0,13,27h3V25H13a2,2,0,0,1-2-2V16h4V14H11V9A2,2,0,0,1,13,7Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  TextSelection.propTypes = iconPropTypes;
}
const TextShortParagraph = /*#__PURE__*/React.forwardRef(function TextShortParagraph({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M6 18H20V20H6z"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M6 12H26V14H6z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  TextShortParagraph.propTypes = iconPropTypes;
}
const TextSmallCaps = /*#__PURE__*/React.forwardRef(function TextSmallCaps({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M23 27L23 15 18 15 18 13 30 13 30 15 25 15 25 27 23 27z"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M11 27L11 8 2 8 2 6 22 6 22 8 13 8 13 27 11 27z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  TextSmallCaps.propTypes = iconPropTypes;
}
const TextStrikethrough = /*#__PURE__*/React.forwardRef(function TextStrikethrough({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M28,15H17.9563c-.4522-.1237-.9037-.2324-1.3381-.3352-2.8077-.6641-4.396-1.1506-4.396-3.4231a2.8684,2.8684,0,0,1,.7866-2.145,4.7888,4.7888,0,0,1,3.0137-1.09c2.8291-.07,4.1347.8894,5.2011,2.35l1.6153-1.1792a7.4727,7.4727,0,0,0-6.83-3.1706,6.7726,6.7726,0,0,0-4.4,1.6611,4.8274,4.8274,0,0,0-1.3862,3.5735A4.3723,4.3723,0,0,0,11.9573,15H4v2H17.6519c1.9668.57,3.1432,1.3123,3.1733,3.3579a3.119,3.119,0,0,1-.8623,2.3931A5.8241,5.8241,0,0,1,16.2432,24a6.6344,6.6344,0,0,1-5.1451-2.6912L9.5649,22.593A8.5262,8.5262,0,0,0,16.2119,26c.0088-.0012.042,0,.1,0A7.67,7.67,0,0,0,21.36,24.1812a5.0779,5.0779,0,0,0,1.4648-3.8531A4.952,4.952,0,0,0,21.6753,17H28Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  TextStrikethrough.propTypes = iconPropTypes;
}
const TextSubscript = /*#__PURE__*/React.forwardRef(function TextSubscript({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M26 25L20 25 20 19 24 19 24 17 20 17 20 15 26 15 26 21 22 21 22 23 26 23 26 25z"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M5 7L5 9 12 9 12 25 14 25 14 9 21 9 21 7 5 7z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  TextSubscript.propTypes = iconPropTypes;
}
const TextSuperscript = /*#__PURE__*/React.forwardRef(function TextSuperscript({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M29 17L23 17 23 11 27 11 27 9 23 9 23 7 29 7 29 13 25 13 25 15 29 15 29 17z"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M4 7L4 9 11 9 11 25 13 25 13 9 20 9 20 7 4 7z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  TextSuperscript.propTypes = iconPropTypes;
}
const TextTracking = /*#__PURE__*/React.forwardRef(function TextTracking({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M25.29 19.29L23.88 20.71 26.17 23 5.83 23 8.12 20.71 6.71 19.29 2 24 6.71 28.71 8.12 27.29 5.83 25 26.17 25 23.88 27.29 25.29 28.71 30 24 25.29 19.29z"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M26,17h2L23,3H21L16,17h2l1-3h6Zm-6.33-5L22,5l2.33,7Z"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M14 3L10 15 6 3 4 3 9 17 11 17 16 3 14 3z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  TextTracking.propTypes = iconPropTypes;
}
const TextUnderline = /*#__PURE__*/React.forwardRef(function TextUnderline({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M4 26H28V28H4z"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M16,23a7,7,0,0,1-7-7V5h2V16a5,5,0,0,0,10,0V5h2V16A7,7,0,0,1,16,23Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  TextUnderline.propTypes = iconPropTypes;
}
const TextVerticalAlignment = /*#__PURE__*/React.forwardRef(function TextVerticalAlignment({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M16 28H30V30H16z"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M16 23H30V25H16z"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8458,30H13L8.64,20H6.36L2,30H4.1542l.8-2h5.0916ZM5.7541,26,7.5,21.6347,9.2459,26Z"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M2 15H30V17H2z"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M16 7H30V9H16z"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M16 2H30V4H16z"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8458,12H13L8.64,2H6.36L2,12H4.1542l.8-2h5.0916ZM5.7541,8,7.5,3.6347,9.2459,8Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  TextVerticalAlignment.propTypes = iconPropTypes;
}
const TextWrap = /*#__PURE__*/React.forwardRef(function TextWrap({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M4 23H12V25H4z"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5232,14H4v2H24.5a3.5,3.5,0,0,1,0,7H18.8281l2.586-2.5859L20,19l-5,5,5,5,1.4141-1.4141L18.8281,25H24.533a5.5,5.5,0,0,0-.01-11Z"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M4 5H28V7H4z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  TextWrap.propTypes = iconPropTypes;
}
const WatsonHealthTextAnnotationToggle = /*#__PURE__*/React.forwardRef(function WatsonHealthTextAnnotationToggle({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M29.537,13.76,26.24,10.463a1.5862,1.5862,0,0,0-2.24,0L10,24.4674V30h5.5326L29.537,16a1.5862,1.5862,0,0,0,0-2.24ZM14.7042,28H12V25.2958l9.4409-9.4409,2.7042,2.7042ZM25.5591,17.145,22.855,14.4409l2.2672-2.2672,2.7042,2.7042Z"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M11 17L13 17 13 10 16 10 16 8 8 8 8 10 11 10 11 17z"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M8,20H4V4H20V8h2V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4V20a2,2,0,0,0,2,2H8Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WatsonHealthTextAnnotationToggle.propTypes = iconPropTypes;
}
const TextLink = /*#__PURE__*/React.forwardRef(function TextLink({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7061,27.585a5.2615,5.2615,0,0,1-3.7227-8.9834l1.415,1.414a3.2638,3.2638,0,1,0,4.6153,4.6162l6.03-6.03a3.264,3.264,0,0,0-4.6162-4.6158l-1.414-1.414a5.2637,5.2637,0,0,1,7.4443,7.4438l-6.03,6.03A5.2461,5.2461,0,0,1,18.7061,27.585Z"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2642,29.9971A5.2619,5.2619,0,0,1,6.542,21.0137l6.03-6.03a5.2636,5.2636,0,1,1,7.4438,7.4438l-1.414-1.414a3.2639,3.2639,0,1,0-4.6158-4.6158l-6.03,6.03a3.264,3.264,0,0,0,4.6157,4.6162l1.414,1.4141A5.2452,5.2452,0,0,1,10.2642,29.9971Z"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M2 10H10V12H2z"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M2 6H14V8H2z"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M2 2H14V4H2z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  TextLink.propTypes = iconPropTypes;
}
const TextLinkAnalysis = /*#__PURE__*/React.forwardRef(function TextLinkAnalysis({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M8 10H16V12H8z"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M8 6H20V8H8z"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M8 2H20V4H8z"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M4.7111,28l5.6312-9.9961,7.4341,6.49A2,2,0,0,0,20.86,23.96l6.9707-10.4034-1.6622-1.1132-7,10.4472-.07.1035-7.4345-6.4907a2.0032,2.0032,0,0,0-3.0806.5308L4,25.1826V2H2V28a2.0023,2.0023,0,0,0,2,2H30V28Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  TextLinkAnalysis.propTypes = iconPropTypes;
}
const TextMining = /*#__PURE__*/React.forwardRef(function TextMining({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M18 28H26V30H18z"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M18 24H30V26H18z"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M18 20H30V22H18z"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M16.001 26.473L16 26.473 4.284 12.955 9.5 6 22.5 6 27.716 12.955 24.476 16.692 25.989 18.002 30.284 13.045 23.5 4 8.5 4 1.716 13.045 14.488 27.782 16.001 26.473z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  TextMining.propTypes = iconPropTypes;
}
const TextMiningApplier = /*#__PURE__*/React.forwardRef(function TextMiningApplier({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M16.001 26.473L16 26.473 4.284 12.955 9.5 6 22.5 6 27.716 12.955 24.476 16.692 25.989 18.002 30.284 13.045 23.5 4 8.5 4 1.716 13.045 14.488 27.782 16.001 26.473z"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M20 19L27 24 20 29 20 19z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  TextMiningApplier.propTypes = iconPropTypes;
}
const Theater = /*#__PURE__*/React.forwardRef(function Theater({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M20,25a6.9908,6.9908,0,0,1-5.833-3.1287l1.666-1.1074a5.0007,5.0007,0,0,0,8.334,0l1.666,1.1074A6.9908,6.9908,0,0,1,20,25Z"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M24,14a2,2,0,1,0,2,2A1.9806,1.9806,0,0,0,24,14Z"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M16,14a2,2,0,1,0,2,2A1.9806,1.9806,0,0,0,16,14Z"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M28,8H22V4a2.0023,2.0023,0,0,0-2-2H4A2.0023,2.0023,0,0,0,2,4V14a10.01,10.01,0,0,0,8.8027,9.9214A9.9989,9.9989,0,0,0,30,20V10A2.0023,2.0023,0,0,0,28,8ZM4,14V4H20V8H12a2.0023,2.0023,0,0,0-2,2V20a9.9628,9.9628,0,0,0,.168,1.78A8.0081,8.0081,0,0,1,4,14Zm24,6a8,8,0,0,1-16,0V10H28Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Theater.propTypes = iconPropTypes;
}
const ThisSideUp = /*#__PURE__*/React.forwardRef(function ThisSideUp({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M2 28H30V30H2z"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M7 5.828L7 24 9 24 9 5.828 12.586 9.414 14 8 8 2 2 8 3.414 9.414 7 5.828z"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M23 5.828L23 24 25 24 25 5.828 28.586 9.414 30 8 24 2 18 8 19.414 9.414 23 5.828z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ThisSideUp.propTypes = iconPropTypes;
}
const WatsonHealthThreshold = /*#__PURE__*/React.forwardRef(function WatsonHealthThreshold({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M26,4H6A2.0025,2.0025,0,0,0,4,6V26a2.0025,2.0025,0,0,0,2,2H26a2.0023,2.0023,0,0,0,2-2V6A2.0023,2.0023,0,0,0,26,4ZM6,6H26V16H24v2h2v2H24v2h2v2H24v2H22V24H20v2H18V24H16v2H14V24H12v2H10V24H8v2H6Z"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M8 20H10V22H8z"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M12 20H14V22H12z"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M16 20H18V22H16z"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M20 20H22V22H20z"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M8 16H10V18H8z"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M16 16H18V18H16z"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M20 16H22V18H20z"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M20 12H22V14H20z"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M20 8H22V10H20z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WatsonHealthThreshold.propTypes = iconPropTypes;
}
const Thumbnail_1 = /*#__PURE__*/React.forwardRef(function Thumbnail_1({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M8,30H4a2,2,0,0,1-2-2V24a2,2,0,0,1,2-2H8a2,2,0,0,1,2,2v4A2,2,0,0,1,8,30ZM4,24v4H8V24Z"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M18,30H14a2,2,0,0,1-2-2V24a2,2,0,0,1,2-2h4a2,2,0,0,1,2,2v4A2,2,0,0,1,18,30Zm-4-6v4h4V24Z"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M28,30H24a2,2,0,0,1-2-2V24a2,2,0,0,1,2-2h4a2,2,0,0,1,2,2v4A2,2,0,0,1,28,30Zm-4-6v4h4V24Z"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M28,20H4a2,2,0,0,1-2-2V4A2,2,0,0,1,4,2H28a2,2,0,0,1,2,2V18A2,2,0,0,1,28,20ZM4,4V18H28V4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Thumbnail_1.propTypes = iconPropTypes;
}
const Thumbnail_2 = /*#__PURE__*/React.forwardRef(function Thumbnail_2({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M8,30H4a2,2,0,0,1-2-2V24a2,2,0,0,1,2-2H8a2,2,0,0,1,2,2v4A2,2,0,0,1,8,30ZM4,24v4H8V24Z"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M18,30H14a2,2,0,0,1-2-2V24a2,2,0,0,1,2-2h4a2,2,0,0,1,2,2v4A2,2,0,0,1,18,30Zm-4-6v4h4V24Z"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M28,30H24a2,2,0,0,1-2-2V24a2,2,0,0,1,2-2h4a2,2,0,0,1,2,2v4A2,2,0,0,1,28,30Zm-4-6v4h4V24Z"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M8,20H4a2,2,0,0,1-2-2V14a2,2,0,0,1,2-2H8a2,2,0,0,1,2,2v4A2,2,0,0,1,8,20ZM4,14v4H8V14Z"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M18,20H14a2,2,0,0,1-2-2V14a2,2,0,0,1,2-2h4a2,2,0,0,1,2,2v4A2,2,0,0,1,18,20Zm-4-6v4h4V14Z"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M28,20H24a2,2,0,0,1-2-2V14a2,2,0,0,1,2-2h4a2,2,0,0,1,2,2v4A2,2,0,0,1,28,20Zm-4-6v4h4V14Z"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M8,10H4A2,2,0,0,1,2,8V4A2,2,0,0,1,4,2H8a2,2,0,0,1,2,2V8A2,2,0,0,1,8,10ZM4,4V8H8V4Z"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M18,10H14a2,2,0,0,1-2-2V4a2,2,0,0,1,2-2h4a2,2,0,0,1,2,2V8A2,2,0,0,1,18,10ZM14,4V8h4V4Z"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M28,10H24a2,2,0,0,1-2-2V4a2,2,0,0,1,2-2h4a2,2,0,0,1,2,2V8A2,2,0,0,1,28,10ZM24,4V8h4V4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Thumbnail_2.propTypes = iconPropTypes;
}
const WatsonHealthThumbnailPreview = /*#__PURE__*/React.forwardRef(function WatsonHealthThumbnailPreview({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M28,12H4a2.0023,2.0023,0,0,0-2,2V28a2.002,2.002,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V14A2.0027,2.0027,0,0,0,28,12ZM20,28H12V27a1.0009,1.0009,0,0,1,1-1h6a1.0009,1.0009,0,0,1,1,1Zm8,0H22V27a3.0033,3.0033,0,0,0-3-3H13a3.0033,3.0033,0,0,0-3,3v1H4V14H28.002Z"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M16,23a4,4,0,1,1,4-4A4.0042,4.0042,0,0,1,16,23Zm0-6a2,2,0,1,0,2,2A2.0023,2.0023,0,0,0,16,17Z"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M30,4V8a2.0027,2.0027,0,0,1-2,2H24a2.0027,2.0027,0,0,1-2-2V4a2.0027,2.0027,0,0,1,2-2h4A2.0027,2.0027,0,0,1,30,4ZM28,8l.002-4H24V8Z"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M20,4V8a2.0027,2.0027,0,0,1-2,2H14a2.0023,2.0023,0,0,1-2-2V4a2.0023,2.0023,0,0,1,2-2h4A2.0027,2.0027,0,0,1,20,4ZM18,8l.002-4H14V8Z"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M10,4V8a2.0023,2.0023,0,0,1-2,2H4A2.0023,2.0023,0,0,1,2,8V4A2.0023,2.0023,0,0,1,4,2H8A2.0023,2.0023,0,0,1,10,4ZM8,8l.0015-4H4V8Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WatsonHealthThumbnailPreview.propTypes = iconPropTypes;
}
const ThumbsDown = /*#__PURE__*/React.forwardRef(function ThumbsDown({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M30,16V9a7.0078,7.0078,0,0,0-7-7H2V16H8.4648l3.5774,5.3662.8453,5.9165A2.0094,2.0094,0,0,0,14.8672,29H17a3.0033,3.0033,0,0,0,3-3V20h6A4.0045,4.0045,0,0,0,30,16ZM8,14H4V4H8Zm20,2a2.0025,2.0025,0,0,1-2,2H18v8a1.0008,1.0008,0,0,1-1,1H14.8672l-.9094-6.3662L10,14.6973V4H23a5.0057,5.0057,0,0,1,5,5Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ThumbsDown.propTypes = iconPropTypes;
}
const ThumbsDownFilled = /*#__PURE__*/React.forwardRef(function ThumbsDownFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M2 2H7V16H2z"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M23,2H9V16.8027l3.0422,4.5635.8453,5.9165A2.0094,2.0094,0,0,0,14.8672,29H15a3.0033,3.0033,0,0,0,3-3V20h8a4.0045,4.0045,0,0,0,4-4V9A7.0078,7.0078,0,0,0,23,2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ThumbsDownFilled.propTypes = iconPropTypes;
}
const ThumbsUp = /*#__PURE__*/React.forwardRef(function ThumbsUp({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M26,12H20V6a3.0033,3.0033,0,0,0-3-3H14.8672a2.0094,2.0094,0,0,0-1.98,1.7173l-.8453,5.9165L8.4648,16H2V30H23a7.0078,7.0078,0,0,0,7-7V16A4.0045,4.0045,0,0,0,26,12ZM8,28H4V18H8Zm20-5a5.0057,5.0057,0,0,1-5,5H10V17.3027l3.9578-5.9365L14.8672,5H17a1.0008,1.0008,0,0,1,1,1v8h8a2.0025,2.0025,0,0,1,2,2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ThumbsUp.propTypes = iconPropTypes;
}
const ThumbsUpFilled = /*#__PURE__*/React.forwardRef(function ThumbsUpFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M2 16H7V30H2z"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M23,30H9V15.1973l3.0422-4.5635.8453-5.9165A2.0094,2.0094,0,0,1,14.8672,3H15a3.0033,3.0033,0,0,1,3,3v6h8a4.0045,4.0045,0,0,1,4,4v7A7.0078,7.0078,0,0,1,23,30Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ThumbsUpFilled.propTypes = iconPropTypes;
}
const ThumbsUpDouble = /*#__PURE__*/React.forwardRef(function ThumbsUpDouble({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8,14h-5.8v-4.4c0-2.1-1.2-3.6-3-3.6h-1c-1.5,0-1.8,1.5-1.9,2.4,0,.1,0,.3-.1.5l-.6,4.3-2,3.9H2v13h16.3c3.7,0,6.7-3,6.7-6.7v-5.1c0-2.4-1.9-4.3-4.2-4.3h0ZM4,28v-9h2v9h-2ZM23,23.3c0,2.6-2.1,4.7-4.7,4.7h-10.3v-9.8l2.4-4.5.6-4.5c0-.2.1-.4.1-.5,0-.2.1-.5.1-.6h.8c1,0,1,1.4,1,1.6v6.3h7.8c1.2,0,2.2,1,2.2,2.2v5.1h0ZM27,9h-6v-4.6c0-2-1.2-3.4-3-3.4h-.8c-1.8,0-2,1.9-2.1,2.6l-.2,2.4h2l.1-1,.1-1.2c0-.5.1-.7.1-.8h.8c.9,0,1,.9,1,1.4v6.6h8c1.2,0,2,.8,2,2v5c0,1.7-.9,3.4-2.1,4.2l1.1,1.7c1.8-1.2,2.9-3.5,2.9-5.9v-5c.1-2.4-1.5-4-3.9-4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ThumbsUpDouble.propTypes = iconPropTypes;
}
const ThumbsUpDoubleFilled = /*#__PURE__*/React.forwardRef(function ThumbsUpDoubleFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8,14h-5.8v-4.4c0-2.1-1.2-3.6-3-3.6h-1c-1.5,0-1.8,1.5-1.9,2.4,0,.1,0,.3-.1.5l-.6,4.3-1.4,2.8v14h11.3c3.7,0,6.7-3,6.7-6.7v-5.1c0-2.3-1.9-4.2-4.2-4.2ZM2,30v-13h3v13h-3ZM26.8,9h-5.8v-4.4c0-2.1-1.2-3.6-3-3.6h-1c-1.5,0-1.8,1.5-1.9,2.3,0,.2,0,.3-.1.5l-.1,1.1c1.3,1,2.1,2.6,2.1,4.6v2.5h3.8c3.4,0,6.2,2.8,6.2,6.2v5.1c0,.4,0,.8-.1,1.1,2.4-1,4.1-3.4,4.1-6.1v-5.1c0-2.3-1.9-4.2-4.2-4.2h0Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ThumbsUpDoubleFilled.propTypes = iconPropTypes;
}
const Thunderstorm = /*#__PURE__*/React.forwardRef(function Thunderstorm({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5,22H23V20h.5a4.5,4.5,0,0,0,.36-9L23,11l-.1-.82a7,7,0,0,0-13.88,0L9,11,8.14,11a4.5,4.5,0,0,0,.36,9H9v2H8.5A6.5,6.5,0,0,1,7.2,9.14a9,9,0,0,1,17.6,0A6.5,6.5,0,0,1,23.5,22Z"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M15.87 30.5L14.13 29.5 17.28 24 11.28 24 16.13 15.5 17.87 16.5 14.72 22 20.72 22 15.87 30.5z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Thunderstorm.propTypes = iconPropTypes;
}
const ThunderstormScattered = /*#__PURE__*/React.forwardRef(function ThunderstormScattered({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M13.338 30L11.602 29 13.889 25 10 25 13.993 18 15.73 19 13.446 23 17.337 23 13.338 30z"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M27,11A5.9955,5.9955,0,0,0,15.6335,8.3311,7.3494,7.3494,0,0,0,13.5,8a7.5509,7.5509,0,0,0-7.1492,5.2441A5.9926,5.9926,0,0,0,8,25V23a3.9925,3.9925,0,0,1-.6731-7.9292L7.99,14.958l.1458-.6562a5.496,5.496,0,0,1,10.7294,0l.1458.6562.6626.1128A3.9925,3.9925,0,0,1,19,23v2a5.9853,5.9853,0,0,0,5.2163-8.9463A5.9941,5.9941,0,0,0,27,11Zm-4.0732,3.4893a5.96,5.96,0,0,0-2.2776-1.2452,7.5157,7.5157,0,0,0-3.1853-4.0688,3.9869,3.9869,0,1,1,5.4629,5.314Z"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M26.732 16.233H29.732V18.233H26.732z",
    transform: "rotate(-135 28.232 17.233)"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M29 10H32V12H29z"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M26.732 3.768H29.732V5.768H26.732z",
    transform: "rotate(-45 28.232 4.768)"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M20 0H22V3H20z"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M12.268 3.768H15.268V5.768H12.268z",
    transform: "rotate(-135 13.768 4.768)"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ThunderstormScattered.propTypes = iconPropTypes;
}
const ThunderstormScatteredNight = /*#__PURE__*/React.forwardRef(function ThunderstormScatteredNight({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M13.338 30L11.602 29 13.889 25 10 25 13.993 18 15.73 19 13.446 23 17.337 23 13.338 30z"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M29.844,13.0347a1.52,1.52,0,0,0-1.231-.8658,5.3562,5.3562,0,0,1-3.4094-1.7158A6.4652,6.4652,0,0,1,23.9187,4.06a1.6039,1.6039,0,0,0-.3-1.5459,1.4547,1.4547,0,0,0-1.3591-.4922l-.0191.0039a7.8544,7.8544,0,0,0-6.1054,6.48A7.3725,7.3725,0,0,0,13.5,8a7.5511,7.5511,0,0,0-7.1494,5.2441A5.9926,5.9926,0,0,0,8,25V23a3.9926,3.9926,0,0,1-.6733-7.9292l.663-.1128.1456-.6562a5.496,5.496,0,0,1,10.7294,0l.1456.6562.6626.1128A3.9925,3.9925,0,0,1,19,23v2a5.9549,5.9549,0,0,0,5.88-7.1455,7.502,7.502,0,0,0,4.8669-3.3A1.537,1.537,0,0,0,29.844,13.0347Zm-5.6926,2.9179a5.9658,5.9658,0,0,0-3.502-2.7085A7.5084,7.5084,0,0,0,18.0288,9.55a6.0085,6.0085,0,0,1,3.77-5.3335,8.4582,8.4582,0,0,0,1.9392,7.5967A7.4037,7.4037,0,0,0,27.64,14.041,5.4419,5.4419,0,0,1,24.1514,15.9526Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ThunderstormScatteredNight.propTypes = iconPropTypes;
}
const ThunderstormSevere = /*#__PURE__*/React.forwardRef(function ThunderstormSevere({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M21,30a1,1,0,0,1-.8944-1.4474l2-4.0005a1,1,0,1,1,1.7887.8947l-2,4A.9981.9981,0,0,1,21,30Z"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M9,32a1,1,0,0,1-.8944-1.4474l2-4.0005a1,1,0,1,1,1.7887.8947l-2,4A.9981.9981,0,0,1,9,32Z"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M15.901 30.496L14.165 29.504 17.309 24 11.31 24 16.165 15.504 17.901 16.496 14.756 22 20.757 22 15.901 30.496z"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9516,15A4.399,4.399,0,0,1,28,15.5,4.5049,4.5049,0,0,1,23.5,20H23v2h.5A6.5075,6.5075,0,0,0,30,15.5c0-.17-.0312-.333-.0444-.5Z"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M25.75,8h-1.5V4h1.5ZM25,9a1,1,0,1,0,1,1A1,1,0,0,0,25,9Z"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9115,11.9355,25.6283.3706a.7181.7181,0,0,0-1.2568,0L18.0883,11.9355A.72.72,0,0,0,18.72,13H31.28A.72.72,0,0,0,31.9115,11.9355ZM24.25,4h1.5V8h-1.5ZM25,11a1,1,0,1,1,1-1A1,1,0,0,1,25,11Z"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M8.144,11.019l.8154-.0639.0991-.812a6.9863,6.9863,0,0,1,9.97-5.45L20,2.9468A8.9777,8.9777,0,0,0,7.2,9.1362,6.4929,6.4929,0,0,0,7.43,21.9043L6.1059,24.5527a1,1,0,1,0,1.7885.8946l2-4a1,1,0,0,0-.4471-1.3418A.9786.9786,0,0,0,9,20.01V20H8.5a4.4975,4.4975,0,0,1-.3559-8.981Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ThunderstormSevere.propTypes = iconPropTypes;
}
const ThunderstormStrong = /*#__PURE__*/React.forwardRef(function ThunderstormStrong({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M21,30a1,1,0,0,1-.8944-1.4474l2-4.0005a1,1,0,1,1,1.7888.8947l-2,4A.9981.9981,0,0,1,21,30Z"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M9,32a1,1,0,0,1-.8944-1.4474l2-4.0005a1,1,0,1,1,1.7888.8947l-2,4A.9981.9981,0,0,1,9,32Z"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M15.901 30.496L14.165 29.504 17.31 24 11.31 24 16.165 15.504 17.901 16.496 14.756 22 20.757 22 15.901 30.496z"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8008,9.1362a8.9943,8.9943,0,0,0-17.6006,0,6.4929,6.4929,0,0,0,.23,12.7681L6.106,24.5527a1,1,0,1,0,1.7885.8946l2-4a1,1,0,0,0-.447-1.3418A.9786.9786,0,0,0,9,20.01V20H8.5a4.4975,4.4975,0,0,1-.356-8.981l.8155-.0639.0991-.812a6.9938,6.9938,0,0,1,13.8838,0l.0986.812.8154.0639A4.4975,4.4975,0,0,1,23.5,20H23v2h.5A6.4974,6.4974,0,0,0,24.8008,9.1362Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ThunderstormStrong.propTypes = iconPropTypes;
}
const Ticket = /*#__PURE__*/React.forwardRef(function Ticket({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M29,14a1,1,0,0,0,1-1V8a2,2,0,0,0-2-2H4A2,2,0,0,0,2,8v5a1,1,0,0,0,1,1,2,2,0,0,1,0,4,1,1,0,0,0-1,1v5a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V19a1,1,0,0,0-1-1,2,2,0,0,1,0-4Zm-1,5.87V24H21V21H19v3H4V19.87a4,4,0,0,0,0-7.74V8H19v3h2V8h7v4.13a4,4,0,0,0,0,7.74Z"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M19 13H21V19H19z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Ticket.propTypes = iconPropTypes;
}
const Tides = /*#__PURE__*/React.forwardRef(function Tides({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M14 7L9 2 4 7 5.413 8.416 8 5.833 8 14 10 14 10 5.833 12.586 8.414 14 7z"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M26.586 7.586L24 10.167 24 2 22 2 22 10.167 19.413 7.584 18 9 23 14 28 9 26.586 7.586z"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M20,20a3.4376,3.4376,0,0,1-3.0513-2.3164A1.007,1.007,0,0,0,16,17a.9894.9894,0,0,0-.9468.6787A3.44,3.44,0,0,1,12,20a3.4376,3.4376,0,0,1-3.0513-2.3164A1.007,1.007,0,0,0,8,17a.971.971,0,0,0-.9468.6787A3.44,3.44,0,0,1,4,20H2v2H4a4.9316,4.9316,0,0,0,4-1.9873,5.0192,5.0192,0,0,0,8,0A4.9316,4.9316,0,0,0,20,22H30V20Z"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M28,28a3.4376,3.4376,0,0,1-3.0513-2.3164A1.007,1.007,0,0,0,24,25a.9894.9894,0,0,0-.9468.6787A3.44,3.44,0,0,1,20,28a3.4376,3.4376,0,0,1-3.0513-2.3164A1.007,1.007,0,0,0,16,25a.971.971,0,0,0-.9468.6787A3.44,3.44,0,0,1,12,28H2v2H12a4.9316,4.9316,0,0,0,4-1.9873,5.0192,5.0192,0,0,0,8,0A4.9316,4.9316,0,0,0,28,30h2V28Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Tides.propTypes = iconPropTypes;
}
const Tif = /*#__PURE__*/React.forwardRef(function Tif({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M30 11L30 9 22 9 22 23 24 23 24 17 29 17 29 15 24 15 24 11 30 11z"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M12 11L15 11 15 21 12 21 12 23 20 23 20 21 17 21 17 11 20 11 20 9 12 9 12 11z"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M2 11L5 11 5 23 7 23 7 11 10 11 10 9 2 9 2 11z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Tif.propTypes = iconPropTypes;
}
const Time = /*#__PURE__*/React.forwardRef(function Time({
  children,
  size = 16,
  ...rest
}, ref) {
  if (size === 20 || size === "20" || size === "20px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 20 20",
      fill: "currentColor",
      ...rest
    }, _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
      d: "M10,19c-5,0-9-4-9-9s4-9,9-9s9,4,9,9S15,19,10,19z M10,2.3c-4.3,0-7.7,3.5-7.7,7.7s3.5,7.7,7.7,7.7s7.7-3.5,7.7-7.7 S14.3,2.3,10,2.3z"
    })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
      d: "M13 13.9L9.4 10.3 9.4 4 10.6 4 10.6 9.7 13.9 13z"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30A14,14,0,1,1,30,16,14,14,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12,12,0,0,0,16,4Z"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M20.59 22L15 16.41 15 7 17 7 17 15.58 22 20.59 20.59 22z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Time.propTypes = iconPropTypes;
}
const TimeFilled = /*#__PURE__*/React.forwardRef(function TimeFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "m16,2c-7.6001,0-14,6.3999-14,14s6.3999,14,14,14,14-6.3999,14-14S23.6001,2,16,2Zm4.5872,20l-5.5872-5.5898V7h2v8.582l5,5.0044-1.4128,1.4136Z"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M20.5872 22L15 16.4099 15 7 17 7 17 15.5822 22 20.5866 20.5872 22z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  TimeFilled.propTypes = iconPropTypes;
}
const TimePlot = /*#__PURE__*/React.forwardRef(function TimePlot({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M23.586 13L21 10.414 21 6 23 6 23 9.586 25 11.586 23.586 13z"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M22,18a8,8,0,1,1,8-8A8.0092,8.0092,0,0,1,22,18ZM22,4a6,6,0,1,0,6,6A6.0066,6.0066,0,0,0,22,4Z"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M8.63,18l7,6H30V22H16.37l-7-6H4V2H2V28a2.0025,2.0025,0,0,0,2,2H30V28H4V18Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  TimePlot.propTypes = iconPropTypes;
}
const Timer = /*#__PURE__*/React.forwardRef(function Timer({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M15 11H17V20H15z"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M13 2H19V4H13z"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M28,9,26.58,7.59,24.33,9.84a10.94,10.94,0,1,0,1.18,1.65ZM16,26a9,9,0,1,1,9-9A9,9,0,0,1,16,26Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Timer.propTypes = iconPropTypes;
}
const TimingBelt = /*#__PURE__*/React.forwardRef(function TimingBelt({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "24",
    r: "1",
    strokeWidth: "0"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m30,12c0-1.8237-1.2344-3.3496-2.9062-3.8286L7.2087,2.207c-.3838-.123-.7847-.207-1.2087-.207-2.2056,0-4,1.7944-4,4,0,.6025.1438,1.1689.3835,1.6816l8.1016,18.6782c.9185,2.1382,3.0442,3.6401,5.5149,3.6401,2.252,0,4.2161-1.249,5.2422-3.0889l8.002-12.5894c.4712-.6562.7559-1.4541.7559-2.3218Zm-14,6c-2.4155,0-4.4971,1.438-5.4475,3.5005l-5.0149-11.5474c.1536.0181.3042.0469.4624.0469,2.2056,0,4-1.7944,4-4,0-.3193-.0474-.6255-.1182-.9233l13.3882,4.0161c-.7771.73-1.27,1.7593-1.27,2.9072,0,2.1465,1.7029,3.8896,3.8267,3.9824l-4.0593,6.3809c-.7148-2.5146-3.0271-4.3633-5.7673-4.3633Zm12-6c0,1.1025-.8972,2-2,2s-2-.8975-2-2,.8972-2,2-2,2,.8975,2,2ZM6,4c1.1028,0,2,.8975,2,2s-.8972,2-2,2-2-.8975-2-2,.8972-2,2-2Zm10,24c-2.2056,0-4-1.7944-4-4s1.7944-4,4-4,4,1.7944,4,4-1.7944,4-4,4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  TimingBelt.propTypes = iconPropTypes;
}
const ToolBox = /*#__PURE__*/React.forwardRef(function ToolBox({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M27,9H24V6a2,2,0,0,0-2-2H10A2,2,0,0,0,8,6V9H5a3,3,0,0,0-3,3V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V12A3,3,0,0,0,27,9ZM10,6H22V9H10ZM28,26H4V17h8v5h8V17h8ZM14,17h4v3H14ZM4,15V12a1,1,0,0,1,1-1H27a1,1,0,0,1,1,1v3Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ToolBox.propTypes = iconPropTypes;
}
const ToolKit = /*#__PURE__*/React.forwardRef(function ToolKit({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M8.9141,24.5l4.257-4.2568-1.414-1.4141L7.5,23.0859l-.793-.7929a.9994.9994,0,0,0-1.414,0l-4,4a.9994.9994,0,0,0,0,1.414l3,3a.9995.9995,0,0,0,1.414,0l4-4a.9994.9994,0,0,0,0-1.414ZM5,28.5859,3.4141,27,6,24.4141,7.5859,26Z"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M24,30a6.0067,6.0067,0,0,1-6-6,5.84,5.84,0,0,1,.2109-1.5469l-8.664-8.6638A5.8483,5.8483,0,0,1,8,14,5.9757,5.9757,0,0,1,2.4228,5.8164l.5577-1.4219L6.293,7.707a1.0233,1.0233,0,0,0,1.4135,0,.999.999,0,0,0,0-1.4141L4.3936,2.979l1.4233-.5571A5.9772,5.9772,0,0,1,14,8a5.84,5.84,0,0,1-.2109,1.5469l8.664,8.6635A5.8548,5.8548,0,0,1,24,18a5.9755,5.9755,0,0,1,5.5771,8.1836L29.02,27.6055,25.707,24.293a1.0233,1.0233,0,0,0-1.4135,0,.999.999,0,0,0-.0005,1.4141L27.6055,29.02l-1.4219.5579A5.96,5.96,0,0,1,24,30ZM10.0625,11.4763,20.5234,21.9375l-.2392.6094A3.9754,3.9754,0,0,0,23.75,27.9922l-.8711-.8711a2.9992,2.9992,0,0,1,0-4.2424,3.0721,3.0721,0,0,1,4.2427.0005l.8706.8708a3.9759,3.9759,0,0,0-5.4458-3.4658l-.6094.2385-10.46-10.46.2392-.6094A3.9755,3.9755,0,0,0,8.2505,4.0078l.8706.8711a2.9992,2.9992,0,0,1,0,4.2424,3.0721,3.0721,0,0,1-4.2427-.0005L4.0078,8.25a3.975,3.975,0,0,0,5.4453,3.4656Z"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1226,2.85a3.0716,3.0716,0,0,0-4.2422,0L17.4,10.33l1.4141,1.414,7.48-7.48a1.0244,1.0244,0,0,1,1.4141,0,1.002,1.002,0,0,1,0,1.4145l-7.48,7.48,1.414,1.4141,7.48-7.4795A3.0031,3.0031,0,0,0,29.1226,2.85Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ToolKit.propTypes = iconPropTypes;
}
const Tools = /*#__PURE__*/React.forwardRef(function Tools({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1,2A9.8,9.8,0,0,0,6.7,3.6L13.1,10a2.1,2.1,0,0,1,.2,3,2.1,2.1,0,0,1-3-.2L3.7,6.4A9.84,9.84,0,0,0,2,12.1,10.14,10.14,0,0,0,12.1,22.2a10.9,10.9,0,0,0,2.6-.3l6.7,6.7a5,5,0,0,0,7.1-7.1l-6.7-6.7a10.9,10.9,0,0,0,.3-2.6A10,10,0,0,0,12.1,2Zm8,10.1a7.61,7.61,0,0,1-.3,2.1l-.3,1.1.8.8L27,22.8a2.88,2.88,0,0,1,.9,2.1A2.72,2.72,0,0,1,27,27a2.9,2.9,0,0,1-4.2,0l-6.7-6.7-.8-.8-1.1.3a7.61,7.61,0,0,1-2.1.3,8.27,8.27,0,0,1-5.7-2.3A7.63,7.63,0,0,1,4,12.1a8.33,8.33,0,0,1,.3-2.2l4.4,4.4a4.14,4.14,0,0,0,5.9.2,4.14,4.14,0,0,0-.2-5.9L10,4.2a6.45,6.45,0,0,1,2-.3,8.27,8.27,0,0,1,5.7,2.3A8.49,8.49,0,0,1,20.1,12.1Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Tools.propTypes = iconPropTypes;
}
const ToolsAlt = /*#__PURE__*/React.forwardRef(function ToolsAlt({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1,16l6.3-6.3c0.8-0.8,0.8-2,0-2.8l-4.2-4.2c-0.8-0.8-2-0.8-2.8,0L16,8.9L9.7,2.6c-0.8-0.8-2-0.8-2.8,0L2.6,6.8 c-0.8,0.8-0.8,2,0,2.8L8.9,16L2,22.9V30h7.1l6.9-6.9l6.3,6.3c0.8,0.8,2,0.8,2.8,0l4.2-4.2c0.8-0.8,0.8-2,0-2.8L23.1,16z M23.8,4 L28,8.2l-6.3,6.3l-4.2-4.2L23.8,4z M8.2,28H4v-4.2l6.3-6.3l4.2,4.2L8.2,28z M23.8,28L4,8.2L8.2,4l3.5,3.5L9.6,9.6l1.4,1.4l2.1-2.1 l4.2,4.2l-2.1,2.1l1.4,1.4l2.1-2.1l4.2,4.2L21,20.9l1.4,1.4l2.1-2.1l3.5,3.5L23.8,28z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ToolsAlt.propTypes = iconPropTypes;
}
const Tornado = /*#__PURE__*/React.forwardRef(function Tornado({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M16 26H20V28H16z"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M12 22H18V24H12z"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M8 18H18V20H8z"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M8 14H20V16H8z"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M10 10H24V12H10z"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M8 6H26V8H8z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Tornado.propTypes = iconPropTypes;
}
const TornadoWarning = /*#__PURE__*/React.forwardRef(function TornadoWarning({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M2 4H18V6H2z"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M4 8H16V10H4z"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M2 12H14V14H2z"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M2 16H12V18H2z"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M4 20H12V22H4z"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M8 24H14V26H8z"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M12 28H16V30H12z"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M23.75,10h-1.5V6h1.5ZM23,11a1,1,0,1,0,1,1A1,1,0,0,0,23,11Z"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9115,13.9355,23.6284,2.3706a.7181.7181,0,0,0-1.2568,0L16.0885,13.9355A.72.72,0,0,0,16.72,15H29.28A.72.72,0,0,0,29.9115,13.9355ZM22.25,6h1.5v4h-1.5ZM23,13a1,1,0,1,1,1-1A1,1,0,0,1,23,13Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  TornadoWarning.propTypes = iconPropTypes;
}
const Touch_1 = /*#__PURE__*/React.forwardRef(function Touch_1({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M20,8H18A5,5,0,0,0,8,8H6A7,7,0,0,1,20,8Z"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M25,15a2.94,2.94,0,0,0-1.47.4A3,3,0,0,0,21,14a2.94,2.94,0,0,0-1.47.4A3,3,0,0,0,16,13.18V8h0a3,3,0,0,0-6,0V19.1L7.77,17.58h0A2.93,2.93,0,0,0,6,17a3,3,0,0,0-2.12,5.13l8,7.3A6.16,6.16,0,0,0,16,31h5a7,7,0,0,0,7-7V18A3,3,0,0,0,25,15Zm1,9a5,5,0,0,1-5,5H16a4.17,4.17,0,0,1-2.76-1L5.29,20.7A1,1,0,0,1,5,20a1,1,0,0,1,1.6-.8L12,22.9V8a1,1,0,0,1,2,0h0V19h2V16a1,1,0,0,1,2,0v3h2V17a1,1,0,0,1,2,0v2h2V18a1,1,0,0,1,2,0Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Touch_1.propTypes = iconPropTypes;
}
const Touch_1Filled = /*#__PURE__*/React.forwardRef(function Touch_1Filled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M13,2A6.0067,6.0067,0,0,0,7,8H9a4,4,0,0,1,8,0h2A6.0067,6.0067,0,0,0,13,2Z"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M21,30H16.5606a4,4,0,0,1-2.7088-1.0566L4.6513,20.4771A2.0018,2.0018,0,0,1,4.77,17.4219a2.0743,2.0743,0,0,1,2.6578.1728L11,20.8569V8a2,2,0,0,1,4,0v7a2,2,0,0,1,4,0v1a2,2,0,0,1,4,0v1a2,2,0,0,1,4,0v7A6,6,0,0,1,21,30Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Touch_1Filled.propTypes = iconPropTypes;
}
const Touch_1Down = /*#__PURE__*/React.forwardRef(function Touch_1Down({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M20,24H18A5,5,0,0,1,8,24H6a7,7,0,0,0,14,0Z"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M28,14V8a7.0085,7.0085,0,0,0-7-7H16a6.1457,6.1457,0,0,0-4.1055,1.5664L3.8833,9.874a2.9986,2.9986,0,0,0,3.881,4.55l.0008.0012L10,12.8955V24a3,3,0,0,0,6,0h0l0-5.1843a2.939,2.939,0,0,0,3.5294-1.2171A2.963,2.963,0,0,0,21,18a2.9936,2.9936,0,0,0,2.5292-1.4014A2.963,2.963,0,0,0,25,17,3.0033,3.0033,0,0,0,28,14Zm-2,0a1,1,0,0,1-2,0V13H22v2a1,1,0,0,1-2,0V13H18v3a1,1,0,0,1-2,0V13H14V24h.0005A1,1,0,0,1,12,24V9.1045L6.6,12.8008a.9993.9993,0,0,1-1.3081-1.5044l7.9507-7.2515A4.1483,4.1483,0,0,1,16,3h5a5.0059,5.0059,0,0,1,5,5Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Touch_1Down.propTypes = iconPropTypes;
}
const Touch_1DownFilled = /*#__PURE__*/React.forwardRef(function Touch_1DownFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M13,30a6.0067,6.0067,0,0,1-6-6H9a4,4,0,0,0,8,0h2A6.0067,6.0067,0,0,1,13,30Z"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M21,2H16.5606a4,4,0,0,0-2.7088,1.0566L4.6513,11.5229A2.0018,2.0018,0,0,0,4.77,14.5781a2.0743,2.0743,0,0,0,2.6578-.1728L11,11.1431V24a2,2,0,0,0,4,0V17a2,2,0,0,0,4,0V16a2,2,0,0,0,4,0V15a2,2,0,0,0,4,0V8A6,6,0,0,0,21,2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Touch_1DownFilled.propTypes = iconPropTypes;
}
const Touch_2 = /*#__PURE__*/React.forwardRef(function Touch_2({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M29,15H27A11,11,0,0,0,5,15H3a13,13,0,0,1,26,0Z"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M25,28H23V15A7,7,0,1,0,9,15V28H7V15a9,9,0,0,1,18,0Z"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M21,20H11V15a5,5,0,0,1,10,0Zm-8-2h6V15a3,3,0,0,0-6,0Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Touch_2.propTypes = iconPropTypes;
}
const Touch_2Filled = /*#__PURE__*/React.forwardRef(function Touch_2Filled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M16,12a3.0033,3.0033,0,0,0-3,3v3h6V15A3.0033,3.0033,0,0,0,16,12Z"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M16,6a9.0092,9.0092,0,0,0-9,9V28H25V15A9.01,9.01,0,0,0,16,6Zm5,14H11V15a5,5,0,0,1,10,0Z"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M29,15H27A11,11,0,0,0,5,15H3a13,13,0,0,1,26,0Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Touch_2Filled.propTypes = iconPropTypes;
}
const TouchInteraction = /*#__PURE__*/React.forwardRef(function TouchInteraction({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M26,21V20a1,1,0,0,1,2,0V30h2V20a3.0033,3.0033,0,0,0-3-3,2.964,2.964,0,0,0-1.4708.4014,2.9541,2.9541,0,0,0-4-1A2.9934,2.9934,0,0,0,19,15a2.96,2.96,0,0,0-1,.1846L18,10h0a3,3,0,0,0-6,0V21.1045L9.7651,19.5752l-.0008.001a2.999,2.999,0,0,0-3.881,4.55L12.3223,30l1.3479-1.478L7.2915,22.7036A.9908.9908,0,0,1,7,22a1.0005,1.0005,0,0,1,1.6-.8008L14,24.8955V10a1,1,0,0,1,2,0h0V21h2V18a1,1,0,0,1,2,0v3h2V19a1,1,0,0,1,2,0v2Z"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M28,12H22V10h6V4H4v6H8v2H4a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,4,2H28a2.0021,2.0021,0,0,1,2,2v6A2.0021,2.0021,0,0,1,28,12Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  TouchInteraction.propTypes = iconPropTypes;
}
const Tour = /*#__PURE__*/React.forwardRef(function Tour({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "m24,18l-4.7788-6.4019c-.7979-1.0562-1.2212-2.302-1.2212-3.5981,0-3.3083,2.6914-6,6-6s6,2.6917,6,6c0,1.2961-.4233,2.542-1.2246,3.6028l-4.7754,6.3972Zm0-14c-2.2056,0-4,1.7944-4,4,0,.8577.2837,1.6865.8203,2.3972l3.1797,4.2595,3.1763-4.2549c.54-.7153.8237-1.5442.8237-2.4019,0-2.2056-1.7944-4-4-4Z"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: "24",
    cy: "8",
    r: "2"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "m28,18v4H4V6h10v-2H4c-1.1045,0-2,.8955-2,2v16c0,1.1045.8955,2,2,2h8v4h-4v2h16v-2h-4v-4h8c1.1046,0,2-.8955,2-2v-4h-2Zm-10,10h-4v-4h4v4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Tour.propTypes = iconPropTypes;
}
const TrafficEvent = /*#__PURE__*/React.forwardRef(function TrafficEvent({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M11 21H17V23H11z"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2456,8,25.96,14H30V12H27.4688l-1.3-4.5488A2.0077,2.0077,0,0,0,24.2456,6H22.8972l-.7287-2.5488A2.0077,2.0077,0,0,0,20.2456,2H7.7544A2.0078,2.0078,0,0,0,5.8315,3.4507L4.5312,8H2v2H6.04L7.7544,4H20.2456l.5715,2H11.7544A2.008,2.008,0,0,0,9.8315,7.45L8.8171,11H7.7144a1.9981,1.9981,0,0,0-1.8916,1.3516L4.5715,16H2v2H4v7a2.0025,2.0025,0,0,0,2,2v3H8V27H20v3h2V27a2.0025,2.0025,0,0,0,2-2V18h2V16H23.4287l-1.251-3.6475A1.9988,1.9988,0,0,0,20.2856,11H10.897l.8574-3ZM22,19v2H20v2h2v2H6V23H8V21H6V19Zm-.3429-2H6.3428l1.3716-4H20.2856Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  TrafficEvent.propTypes = iconPropTypes;
}
const TrafficFlow = /*#__PURE__*/React.forwardRef(function TrafficFlow({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M26 8L22 4 18 8 19.41 9.42 21 7.83 21 18 23 18 23 7.83 24.58 9.41 26 8z"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M12.59 22.58L11 24.17 11 14 9 14 9 24.17 7.42 22.59 6 24 10 28 14 24 12.59 22.58z"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M2 2H4V30H2z"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M28 2H30V30H28z"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M15 2H17V6H15z"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M15 10H17V14H15z"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M15 18H17V22H15z"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M15 26H17V30H15z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  TrafficFlow.propTypes = iconPropTypes;
}
const TrafficFlowIncident = /*#__PURE__*/React.forwardRef(function TrafficFlowIncident({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M26 9.42L24.59 8 22.005 10.585 22 10.58 21.995 10.585 19.42 8.01 18 9.42 20.58 12 18 14.58 19.41 16 21.995 13.415 22 13.42 22.005 13.415 24.58 15.99 26 14.58 23.42 12 26 9.42z"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M14 17.42L12.59 16 10.005 18.585 10 18.58 9.995 18.585 7.42 16.01 6 17.42 8.58 20 6 22.58 7.41 24 9.995 21.415 10 21.42 10.005 21.415 12.58 23.99 14 22.58 11.42 20 14 17.42z"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M2 2H4V30H2z"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M28 2H30V30H28z"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M15 2H17V6H15z"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M15 10H17V14H15z"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M15 18H17V22H15z"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M15 26H17V30H15z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  TrafficFlowIncident.propTypes = iconPropTypes;
}
const TrafficIncident = /*#__PURE__*/React.forwardRef(function TrafficIncident({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M2 28H30V30H2z"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M11.314 11.514H17.314V13.514H11.314z",
    transform: "rotate(-45 14.314 12.514)"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0815,23.4329l4.1168,2.3176a2.009,2.009,0,0,0,2.3853-.3344l8.8326-8.8326a2.0088,2.0088,0,0,0,.334-2.3856l-2.2977-4.136,1.79-1.79L25.8283,6.8577,24.4141,8.2719l-4.95-4.95a2.0026,2.0026,0,0,0-2.8285,0L14.5146,1.2008,13.1,2.615l2.1213,2.1214L6.7364,13.2216,4.6151,11.1,3.2009,12.5145l2.1213,2.1213a2.0025,2.0025,0,0,0,0,2.8285l4.95,4.95L8.8577,23.8282l1.4143,1.4142Zm13.92-8.2636-8.8328,8.8328-4.5456-2.5255L23.4767,10.6235ZM9.5649,18.8785l1.4142-1.4142L9.5649,16.05,8.1506,17.4643,6.7364,16.05,18.05,4.7364l1.4143,1.4142L18.05,7.5648,19.4644,8.979l1.4142-1.4142L22.2928,8.979,10.9791,20.2927Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  TrafficIncident.propTypes = iconPropTypes;
}
const TrafficWeatherIncident = /*#__PURE__*/React.forwardRef(function TrafficWeatherIncident({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M2 24H4V30H2z"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M28 2H30V30H28z"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M15 2H17V6H15z"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M15 10H17V14H15z"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M15 18H17V22H15z"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M15 26H17V30H15z"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M6,12A3.8978,3.8978,0,0,1,2,8.223a3.9017,3.9017,0,0,1,.6533-2.0639L5.17,2.4141a1.0381,1.0381,0,0,1,1.6592,0L9.3154,6.11A3.9693,3.9693,0,0,1,10,8.223,3.8978,3.8978,0,0,1,6,12Zm0-7.2368L4.3438,7.2257A1.89,1.89,0,0,0,4,8.223a1.9007,1.9007,0,0,0,2,1.7775A1.9007,1.9007,0,0,0,8,8.223a1.98,1.98,0,0,0-.375-1.0466Z"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M11,11.7627,9.3438,14.2253A1.89,1.89,0,0,0,9,15.2226,1.9007,1.9007,0,0,0,11,17a1.9007,1.9007,0,0,0,2-1.7774,1.98,1.98,0,0,0-.375-1.0467Z"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M6,15.7627,4.3438,18.2253A1.89,1.89,0,0,0,4,19.2226,1.9007,1.9007,0,0,0,6,21a1.9007,1.9007,0,0,0,2-1.7774,1.98,1.98,0,0,0-.375-1.0467Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  TrafficWeatherIncident.propTypes = iconPropTypes;
}
const TrafficCone = /*#__PURE__*/React.forwardRef(function TrafficCone({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7957,28,18.9746,2.7754A1,1,0,0,0,18,2H14a1,1,0,0,0-.9746.7754L7.2043,28H4v2H28V28ZM19.9736,16H12.0264l.9229-4h6.1014Zm.4616,2,.923,4H10.6418l.923-4Zm-5.64-14h2.4092l1.3845,6H13.4109ZM10.18,24H21.82l.923,4H9.2573Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  TrafficCone.propTypes = iconPropTypes;
}
const Train = /*#__PURE__*/React.forwardRef(function Train({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M21,3H11A5.0057,5.0057,0,0,0,6,8V20a4.99,4.99,0,0,0,3.582,4.77L7.7693,29H9.9451l1.7143-4h8.6812l1.7143,4h2.1758L22.418,24.77A4.99,4.99,0,0,0,26,20V8A5.0057,5.0057,0,0,0,21,3ZM11,5H21a2.9948,2.9948,0,0,1,2.8157,2H8.1843A2.9948,2.9948,0,0,1,11,5ZM24,19H21v2h2.8157A2.9948,2.9948,0,0,1,21,23H11a2.9948,2.9948,0,0,1-2.8157-2H11V19H8V17H24Zm0-4H8V9H24Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Train.propTypes = iconPropTypes;
}
const TrainHeart = /*#__PURE__*/React.forwardRef(function TrainHeart({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M27.303,2a2.6613,2.6613,0,0,0-1.9079.8059l-.3932.4053-.397-.4053a2.6612,2.6612,0,0,0-3.8157,0,2.7991,2.7991,0,0,0,0,3.8963L25.0019,11l4.2089-4.2978a2.7991,2.7991,0,0,0,0-3.8963A2.6613,2.6613,0,0,0,27.303,2Z"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M22,13v3H6V10h9V8H6.1843A2.9948,2.9948,0,0,1,9,6h6V4H9A5.0057,5.0057,0,0,0,4,9V21a4.99,4.99,0,0,0,3.582,4.77L5.7693,30H7.9451l1.7143-4h8.6812l1.7143,4h2.1758L20.418,25.77A4.99,4.99,0,0,0,24,21V13Zm0,7H19v2h2.8157A2.9948,2.9948,0,0,1,19,24H9a2.9948,2.9948,0,0,1-2.8157-2H9V20H6V18H22Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  TrainHeart.propTypes = iconPropTypes;
}
const TrainProfile = /*#__PURE__*/React.forwardRef(function TrainProfile({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M30 25L2 25 2 27 4 27 4 29 6 29 6 27 11 27 11 29 13 29 13 27 18 27 18 29 20 29 20 27 25 27 25 29 27 29 27 27 30 27 30 25z"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M8,16H2V14H8V12H2V10H8a2.0021,2.0021,0,0,1,2,2v2A2.0021,2.0021,0,0,1,8,16Z"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M28.55,14.2305,19.97,6.3657A8.9775,8.9775,0,0,0,13.8882,4H2V6H12v4a2.0023,2.0023,0,0,0,2,2h9.1565l4.0417,3.7051A2.4723,2.4723,0,0,1,25.5273,20H2v2H25.5273a4.4726,4.4726,0,0,0,3.0225-7.77ZM14,10V6.0054A6.9774,6.9774,0,0,1,18.6182,7.84L20.9746,10Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  TrainProfile.propTypes = iconPropTypes;
}
const TrainSpeed = /*#__PURE__*/React.forwardRef(function TrainSpeed({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M30 25L2 25 2 27 4 27 4 29 6 29 6 27 11 27 11 29 13 29 13 27 18 27 18 29 20 29 20 27 25 27 25 29 27 29 27 27 30 27 30 25z"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7144,16.59,18.1494,8.64A14.9327,14.9327,0,0,0,9.6519,6H2V8H9.6519a12.9459,12.9459,0,0,1,7.3647,2.2871L18.0532,11H9v2H20.9624l7.6187,5.2378A.966.966,0,0,1,28.0342,20H2v2H28.0342a2.9661,2.9661,0,0,0,1.68-5.41Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  TrainSpeed.propTypes = iconPropTypes;
}
const TrainTicket = /*#__PURE__*/React.forwardRef(function TrainTicket({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1257,7.125a1.125,1.125,0,1,1,0-2.25h.875V2h-12V4.875h.875a1.125,1.125,0,0,1,0,2.25h-.875V10h12V7.125Z"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0007,13v3h-16V10h9V8H6.185A2.9948,2.9948,0,0,1,9.0007,6h6V4h-6a5.0057,5.0057,0,0,0-5,5V21a4.99,4.99,0,0,0,3.582,4.77L5.77,30H7.9458L9.66,26h8.6812l1.7143,4h2.1758l-1.8127-4.23A4.99,4.99,0,0,0,24.0007,21V13Zm0,7h-3v2h2.8157a2.9948,2.9948,0,0,1-2.8157,2h-10A2.9948,2.9948,0,0,1,6.185,22H9.0007V20h-3V18h16Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  TrainTicket.propTypes = iconPropTypes;
}
const TrainTime = /*#__PURE__*/React.forwardRef(function TrainTime({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M25.496 10.088L22.874 7.466 22.874 3 25.124 3 25.124 6.534 27.088 8.498 25.496 10.088z"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M24,1a6,6,0,1,0,6,6A6.0066,6.0066,0,0,0,24,1Zm1.4971,9.0884L22.875,7.4658V3h2.25V6.5342l1.9639,1.9634Z"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M6,16V10h9V8H6.1843A2.9948,2.9948,0,0,1,9,6h6V4H9A5.0057,5.0057,0,0,0,4,9V21a4.99,4.99,0,0,0,3.582,4.77L5.7693,30H7.9451l1.7143-4h8.6812l1.7143,4h2.1758L20.418,25.77A4.99,4.99,0,0,0,24,21V16Zm16,4H19v2h2.8157A2.9948,2.9948,0,0,1,19,24H9a2.9948,2.9948,0,0,1-2.8157-2H9V20H6V18H22Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  TrainTime.propTypes = iconPropTypes;
}
const Tram = /*#__PURE__*/React.forwardRef(function Tram({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M21,6H17V4h6V2H9V4h6V6H11a5.0057,5.0057,0,0,0-5,5V22a4.99,4.99,0,0,0,3.582,4.77L8.1978,30h2.1757l1.2859-3h8.6812l1.2859,3h2.1757L22.418,26.77A4.99,4.99,0,0,0,26,22V11A5.0057,5.0057,0,0,0,21,6ZM11,8H21a2.9948,2.9948,0,0,1,2.8157,2H8.1843A2.9948,2.9948,0,0,1,11,8ZM24,21H21v2h2.8157A2.9948,2.9948,0,0,1,21,25H11a2.9948,2.9948,0,0,1-2.8157-2H11V21H8V19H24Zm0-4H8V12H24Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Tram.propTypes = iconPropTypes;
}
const TransformBinary = /*#__PURE__*/React.forwardRef(function TransformBinary({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M23,20h-2c-1.1,0-2-0.9-2-2v-4c0-1.1,0.9-2,2-2h2c1.1,0,2,0.9,2,2v4C25,19.1,24.1,20,23,20z M21,14v4h2v-4H21z"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M15 12H17V20H15z"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M11,20H9c-1.1,0-2-0.9-2-2v-4c0-1.1,0.9-2,2-2h2c1.1,0,2,0.9,2,2v4C13,19.1,12.1,20,11,20z M9,14v4h2v-4H9z"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2v2c6.6,0,12,5.4,12,12s-5.4,12-12,12v2c7.7,0,14-6.3,14-14S23.7,2,16,2z"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M8.2,25.1L7,26.7c1.2,1,2.6,1.9,4.2,2.4l0.7-1.9C10.5,26.7,9.3,26,8.2,25.1z"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M4.2,18l-2,0.4C2.5,20,3.1,21.6,3.9,23l1.7-1C4.9,20.8,4.4,19.4,4.2,18z"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M5.6,10L3.9,9c-0.8,1.4-1.4,3-1.6,4.6l2,0.3C4.4,12.5,4.9,11.2,5.6,10z"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8,4.8l-0.7-1.9C9.6,3.5,8.2,4.3,7,5.3l1.3,1.5C9.3,6,10.5,5.3,11.8,4.8z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  TransformBinary.propTypes = iconPropTypes;
}
const TransformCode = /*#__PURE__*/React.forwardRef(function TransformCode({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9005,4.7366c-1.325.4839-2.5369,1.2001-3.5983,2.0895l-1.2829-1.5289c1.2383-1.0377,2.6521-1.8732,4.1979-2.4378l.6832,1.8772ZM3.9009,9.0146c-.8087,1.3865-1.3839,2.9225-1.6776,4.5562l1.9838.3498c.2518-1.3993.7294-2.7205,1.4221-3.9081l-1.7283-.9979ZM4.1932,18.0818l-1.9678.347c.2878,1.6357.8603,3.1745,1.6635,4.5635l1.7302-.9989c-.6884-1.1906-1.1791-2.5095-1.4258-3.9116ZM8.3065,25.1687l-1.293,1.541c1.2365,1.042,2.6556,1.8721,4.2007,2.4393l.6859-1.8845c-1.3211-.489-2.5342-1.203-3.5936-2.0958ZM29.7747,13.5712c-.2878-1.6357-.8603-3.1745-1.6635-4.5635-.8185-1.4156-1.8817-2.67-3.1246-3.7173-1.2365-1.042-2.6557-1.872-4.2007-2.4392-1.493-.5482-3.1035-.8511-4.7858-.8511v2c1.4429,0,2.8219.2625,4.0999.7355,1.321.489,2.5342,1.2031,3.5934,2.0958.4588.3867.8842.8102,1.2835,1.2573.5247.5933.9986,1.2321,1.3982,1.9213.6902,1.1904,1.1827,2.5085,1.4306,3.9084.12.6777.1943,1.3708.1943,2.0817,0,.7123-.0859,1.4019-.2086,2.0792-.2529,1.397-.7322,2.7173-1.4267,3.9049-.7058,1.2069-1.6058,2.2883-2.6725,3.1831-1.061.8899-2.2716,1.6071-3.5941,2.0923-1.2819.4703-2.6584.7405-4.0981.7405v2c1.6817,0,3.2878-.3134,4.7828-.8594,1.5458-.5646,2.9597-1.4001,4.1979-2.4378,1.2458-1.044,2.2957-2.3068,3.1183-3.7174.8087-1.3865,1.3839-2.9225,1.6776-4.5562.1418-.7889.2234-1.5988.2234-2.4292,0-.8298-.0862-1.6384-.2253-2.4288ZM12.7233,14.1082l.9186-.9185.7781-.778-1.4195-1.4117-.6503.6503-1.4218,1.4217-1.729,1.7289-1.1994,1.1993,1.1991,1.1989,1.7292,1.729,1.4218,1.4216.6504.6503,1.4195-1.4118-.7781-.7779-.9186-.9185-1.1173-1.1171-.7748-.7745.7751-.775,1.1171-1.1171ZM19.2768,17.8918l-.9186.9185-.7781.7779,1.4195,1.4118.6504-.6503,1.4218-1.4216,1.7292-1.729,1.1991-1.1989-1.1994-1.1993-1.7291-1.7289-1.4217-1.4217-.6503-.6503-1.4195,1.4117.7781.778.9186.9185,1.1171,1.1171.7751.775-.7748.7745-1.1173,1.1171Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  TransformCode.propTypes = iconPropTypes;
}
const TransformInstructions = /*#__PURE__*/React.forwardRef(function TransformInstructions({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M23,17v-2h-2.1c-0.1-0.6-0.4-1.2-0.7-1.8l1.5-1.5l-1.4-1.4l-1.5,1.5c-0.5-0.3-1.1-0.6-1.8-0.7V9h-2v2.1 c-0.6,0.1-1.2,0.4-1.8,0.7l-1.5-1.5l-1.4,1.4l1.5,1.5c-0.3,0.5-0.6,1.1-0.7,1.8H9v2h2.1c0.1,0.6,0.4,1.2,0.7,1.8l-1.5,1.5l1.4,1.4 l1.5-1.5c0.5,0.3,1.1,0.6,1.8,0.7V23h2v-2.1c0.6-0.1,1.2-0.4,1.8-0.7l1.5,1.5l1.4-1.4l-1.5-1.5c0.3-0.5,0.6-1.1,0.7-1.8H23z M16,19 c-1.7,0-3-1.3-3-3s1.3-3,3-3s3,1.3,3,3S17.7,19,16,19z"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2v2c6.6,0,12,5.4,12,12s-5.4,12-12,12v2c7.7,0,14-6.3,14-14S23.7,2,16,2z"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M8.2,25.1L7,26.7c1.2,1,2.6,1.9,4.2,2.4l0.7-1.9C10.5,26.7,9.3,26,8.2,25.1z"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M4.2,18l-2,0.4C2.5,20,3.1,21.6,3.9,23l1.7-1C4.9,20.8,4.4,19.4,4.2,18z"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M5.6,10L3.9,9c-0.8,1.4-1.4,3-1.6,4.6l2,0.3C4.4,12.5,4.9,11.2,5.6,10z"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8,4.8l-0.7-1.9C9.6,3.5,8.2,4.3,7,5.3l1.3,1.5C9.3,6,10.5,5.3,11.8,4.8z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  TransformInstructions.propTypes = iconPropTypes;
}
const TransformLanguage = /*#__PURE__*/React.forwardRef(function TransformLanguage({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M10 19H18V21H10z"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M10 15H22V17H10z"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M10 11H22V13H10z"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2v2c6.6,0,12,5.4,12,12s-5.4,12-12,12v2c7.7,0,14-6.3,14-14S23.7,2,16,2z"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M8.2,25.1L7,26.7c1.2,1,2.6,1.9,4.2,2.4l0.7-1.9C10.5,26.7,9.3,26,8.2,25.1z"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M4.2,18l-2,0.4C2.5,20,3.1,21.6,3.9,23l1.7-1C4.9,20.8,4.4,19.4,4.2,18z"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M5.6,10L3.9,9c-0.8,1.4-1.4,3-1.6,4.6l2,0.3C4.4,12.5,4.9,11.2,5.6,10z"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8,4.8l-0.7-1.9C9.6,3.5,8.2,4.3,7,5.3l1.3,1.5C9.3,6,10.5,5.3,11.8,4.8z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  TransformLanguage.propTypes = iconPropTypes;
}
const Transgender = /*#__PURE__*/React.forwardRef(function Transgender({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M22,2V4h4.5859l-6.4016,6.4014a6.9474,6.9474,0,0,0-8.3686,0L10.4143,9,13,6.4141,11.5857,5,9,7.5859,5.4141,4H10V2H2v8H4V5.4141L7.5859,9,5,11.5854,6.4143,13,9,10.4141l1.4014,1.4013A6.9785,6.9785,0,0,0,15,22.92V25H11v2h4v3h2V27h4V25H17V22.92a6.9785,6.9785,0,0,0,4.5984-11.1045L28,5.4141V10h2V2ZM16,21a5,5,0,1,1,5-5A5.0059,5.0059,0,0,1,16,21Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Transgender.propTypes = iconPropTypes;
}
const Translate = /*#__PURE__*/React.forwardRef(function Translate({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M27.85,29H30L24,14H21.65l-6,15H17.8l1.6-4h6.85ZM20.2,23l2.62-6.56L25.45,23Z"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M18,7V5H11V2H9V5H2V7H12.74a14.71,14.71,0,0,1-3.19,6.18A13.5,13.5,0,0,1,7.26,9H5.16a16.47,16.47,0,0,0,3,5.58A16.84,16.84,0,0,1,3,18l.75,1.86A18.47,18.47,0,0,0,9.53,16a16.92,16.92,0,0,0,5.76,3.84L16,18a14.48,14.48,0,0,1-5.12-3.37A17.64,17.64,0,0,0,14.8,7Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Translate.propTypes = iconPropTypes;
}
const TransmissionLte = /*#__PURE__*/React.forwardRef(function TransmissionLte({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M10.57,30l.9333-2h8.9928l.9333,2h2.2072L17,15.7778V11H15v4.7778L8.3631,30ZM16,18.3647,17.6965,22h-3.393ZM13.37,24h5.26l.9333,2H12.4369Z"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7832,9.3325a7.0007,7.0007,0,0,1,10.4341,0l-1.49,1.334a5,5,0,0,0-7.4537,0Z"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M7.1992,6.3994a11.0019,11.0019,0,0,1,17.6006,0L23.2,7.6a9.0009,9.0009,0,0,0-14.4014,0Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  TransmissionLte.propTypes = iconPropTypes;
}
const Transpose = /*#__PURE__*/React.forwardRef(function Transpose({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M19,26H14V24h5a5.0055,5.0055,0,0,0,5-5V14h2v5A7.0078,7.0078,0,0,1,19,26Z"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M8,30H4a2.0023,2.0023,0,0,1-2-2V14a2.0023,2.0023,0,0,1,2-2H8a2.0023,2.0023,0,0,1,2,2V28A2.0023,2.0023,0,0,1,8,30ZM4,14V28H8V14Z"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M28,10H14a2.0023,2.0023,0,0,1-2-2V4a2.0023,2.0023,0,0,1,2-2H28a2.0023,2.0023,0,0,1,2,2V8A2.0023,2.0023,0,0,1,28,10ZM14,4V8H28V4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Transpose.propTypes = iconPropTypes;
}
const TrashCan = /*#__PURE__*/React.forwardRef(function TrashCan({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M12 12H14V24H12z"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M18 12H20V24H18z"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M4,6V8H6V28a2,2,0,0,0,2,2H24a2,2,0,0,0,2-2V8h2V6ZM8,28V8H24V28Z"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M12 2H20V4H12z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  TrashCan.propTypes = iconPropTypes;
}
const Tree = /*#__PURE__*/React.forwardRef(function Tree({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M12,30H9V28h3V15.5664L8.4854,13.4575l1.0292-1.7148,3.5147,2.1084A2.0115,2.0115,0,0,1,14,15.5664V28A2.0023,2.0023,0,0,1,12,30Z"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M22,30H19a2.0024,2.0024,0,0,1-2-2V17h6a4.0008,4.0008,0,0,0,3.981-4.396A4.1489,4.1489,0,0,0,22.7853,9H21.2016L21.025,8.221C20.452,5.6961,18.0308,4,15,4A6.02,6.02,0,0,0,9.5585,7.4859L9.25,8.1531l-.863-.1143A2.771,2.771,0,0,0,8,8a4,4,0,1,0,0,8v2A6,6,0,1,1,8,6c.0264,0,.0525,0,.0786.001A8.0271,8.0271,0,0,1,15,2c3.6788,0,6.6923,1.9776,7.7516,5h.0337a6.1641,6.1641,0,0,1,6.1872,5.4141A6.0011,6.0011,0,0,1,23,19l-4,0v9h3Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Tree.propTypes = iconPropTypes;
}
const TreeFallRisk = /*#__PURE__*/React.forwardRef(function TreeFallRisk({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M23.75,10h-1.5V6h1.5ZM23,11a1,1,0,1,0,1,1A1,1,0,0,0,23,11Z",
    "data-icon-path": "inner-path"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9115,13.9355,23.6284,2.3706a.7181.7181,0,0,0-1.2568,0L16.0885,13.9355A.72.72,0,0,0,16.72,15H29.28A.72.72,0,0,0,29.9115,13.9355ZM22.25,6h1.5v4h-1.5ZM23,13a1,1,0,1,1,1-1A1,1,0,0,1,23,13Z"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M26,19V17H17V28a2.0027,2.0027,0,0,0,2,2h3V28H19V19Z"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M12,30H9V28h3V15.5664L8.4854,13.4575l1.0292-1.7148,3.5147,2.1084A2.0115,2.0115,0,0,1,14,15.5664V28A2.0024,2.0024,0,0,1,12,30Z"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6638,5.0059l.96-1.7671A8.9324,8.9324,0,0,0,15,2,8.0275,8.0275,0,0,0,8.0786,6.001C8.0525,6,8.0264,6,8,6A6,6,0,0,0,8,18V16A4,4,0,0,1,8,8a2.7009,2.7009,0,0,1,.387.0391l.863.1142.3086-.6675A6.0192,6.0192,0,0,1,15,4,6.8916,6.8916,0,0,1,18.6638,5.0059Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  TreeFallRisk.propTypes = iconPropTypes;
}
const TreeView = /*#__PURE__*/React.forwardRef(function TreeView({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M30,20V12H22v3H17V7a2,2,0,0,0-2-2H10V2H2v8h8V7h5V25a2,2,0,0,0,2,2h5v3h8V22H22v3H17V17h5v3ZM8,8H4V4H8ZM24,24h4v4H24Zm0-10h4v4H24Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  TreeView.propTypes = iconPropTypes;
}
const TreeViewAlt = /*#__PURE__*/React.forwardRef(function TreeViewAlt({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M23,9h6a2,2,0,0,0,2-2V3a2,2,0,0,0-2-2H23a2,2,0,0,0-2,2V4H11V3A2,2,0,0,0,9,1H3A2,2,0,0,0,1,3V7A2,2,0,0,0,3,9H9a2,2,0,0,0,2-2V6h4V26a2.0023,2.0023,0,0,0,2,2h4v1a2,2,0,0,0,2,2h6a2,2,0,0,0,2-2V25a2,2,0,0,0-2-2H23a2,2,0,0,0-2,2v1H17V17h4v1a2,2,0,0,0,2,2h6a2,2,0,0,0,2-2V14a2,2,0,0,0-2-2H23a2,2,0,0,0-2,2v1H17V6h4V7A2,2,0,0,0,23,9Zm0-6h6V7H23ZM9,7H3V3H9ZM23,25h6v4H23Zm0-11h6v4H23Z",
    transform: "translate(0 .005)"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  TreeViewAlt.propTypes = iconPropTypes;
}

export { TcpIpService, Temperature, TemperatureCelsius, TemperatureCelsiusAlt, TemperatureFahrenheit, TemperatureFahrenheitAlt, TemperatureFeelsLike, TemperatureFrigid, TemperatureHot, TemperatureInversion, TemperatureMax, TemperatureMin, TemperatureWater, Template, Tennis, TennisBall, Term, TermReference, Terminal, Terminal_3270, TestTool, TextAlignCenter, TextAlignJustify, TextAlignLeft, TextAlignMixed, TextAlignRight, TextAllCaps, TextBold, TextClearFormat, TextColor, TextCreation, TextFill, TextFont, TextFootnote, TextHighlight, TextIndent, TextIndentLess, TextIndentMore, TextItalic, TextKerning, TextLeading, TextLineSpacing, TextLink, TextLinkAnalysis, TextLongParagraph, TextMining, TextMiningApplier, TextNewLine, TextScale, TextSelection, TextShortParagraph, TextSmallCaps, TextStrikethrough, TextSubscript, TextSuperscript, TextTracking, TextUnderline, TextVerticalAlignment, TextWrap, Theater, ThisSideUp, Thumbnail_1, Thumbnail_2, ThumbsDown, ThumbsDownFilled, ThumbsUp, ThumbsUpDouble, ThumbsUpDoubleFilled, ThumbsUpFilled, Thunderstorm, ThunderstormScattered, ThunderstormScatteredNight, ThunderstormSevere, ThunderstormStrong, Ticket, Tides, Tif, Time, TimeFilled, TimePlot, Timer, TimingBelt, ToolBox, ToolKit, Tools, ToolsAlt, Tornado, TornadoWarning, TouchInteraction, Touch_1, Touch_1Down, Touch_1DownFilled, Touch_1Filled, Touch_2, Touch_2Filled, Tour, TrafficCone, TrafficEvent, TrafficFlow, TrafficFlowIncident, TrafficIncident, TrafficWeatherIncident, Train, TrainHeart, TrainProfile, TrainSpeed, TrainTicket, TrainTime, Tram, TransformBinary, TransformCode, TransformInstructions, TransformLanguage, Transgender, Translate, TransmissionLte, Transpose, TrashCan, Tree, TreeFallRisk, TreeView, TreeViewAlt, WatsonHealthTextAnnotationToggle, WatsonHealthThreshold, WatsonHealthThumbnailPreview };
